<template>
  <div class="layout">
    <el-container>
      <!-- 头部 -->
      <el-header class="header">
        <div class="header-container">
          <div class="header-content">
            <div class="logo">
              <img :src="require('../../assets/images/logo.png')" alt="网站logo">
            </div>
            <div style="display: flex; align-items: center; flex: 1; justify-content: flex-start; margin-left: 20px;">
              <el-menu :default-active="getActiveMenuIndex" mode="horizontal" router background-color="#010306"
                text-color="#fff" active-text-color="#316CF4">
                <el-menu-item index="/">首页</el-menu-item>
                <div class="marketing-menu-item" @mouseenter="handleMarketingMouseEnter"
                  @mouseleave="handleMarketingMouseLeave"
                  :class="{ 'is-active': $route.path === '/aiEnterpriseMarketing' }">
                  <span @click="goToAIEnterpriseMarketing">AI企业营销</span>
                  <!-- AI企业营销悬停弹窗 -->
                  <div v-if="showMarketingPopup" class="marketing-popup" @mouseenter="handleMarketingPopupEnter"
                    @mouseleave="handleMarketingPopupLeave">
                    <div class="popup-header">
                      <span class="popup-title" @click="goToAIEnterpriseMarketing">AI企业营销 ></span>
                      <img src="@/assets/images/M-2502.png" alt="关闭" class="popup-close"
                        @click.stop="closeMarketingPopup">
                    </div>
                    <div class="popup-divider"></div>
                    <div class="popup-content">
                      <div class="popup-item" @click="goToBulletScreen">
                        <div class="item-title">自动评论/弹幕推广 ></div>
                        <div class="item-desc">AI智能生成推广软文，精准投放到弹幕和评论区，支持多平台批量推广</div>
                      </div>
                      <div class="popup-item" @click="goToEmailPushing">
                        <div class="item-title">营销邮件推送 ></div>
                        <div class="item-desc">大批量推送营销邮件，轻松触达潜在客户</div>
                      </div>
                    </div>
                  </div>
                </div>
                <el-menu-item index="/workflow">工作流</el-menu-item>
                <el-menu-item index="/agent">智能体</el-menu-item>
              </el-menu>
              <div class="about-us-link" @click="openAboutUs">关于我们</div>

            </div>

            <div class="user-info">
              <!-- <div
                style="display: flex; flex-direction: column; min-width: 30px; font-weight: 500; font-size: 14px; color: #C1C1C2; align-items: center;">
              <img :src="require('../../assets/images/mobile.png')" style="width: 18px; height: 18px;" alt="手机端">
              <label>手机端</label>
            </div> -->

              <!-- 全部产品模块：仅点击下拉箭头展开弹窗 -->
              <div class="all-products-module">
                <img src="@/assets/images/all-product/all.png" alt="全部产品" class="all-products-module__icon">
                <span class="all-products-module__text">全部产品</span>
                <img src="@/assets/images/all-product/all-down.png" alt="展开箭头" class="all-products-module__arrow"
                  title="展开全部产品" @click.stop="toggleAllProducts">

                <!-- 全部产品下拉弹窗 -->
                <transition name="products-pop">
                  <div v-if="showAllProductsPopup" class="all-products-popup">
                    <a v-for="item in allProductList" :key="item.name" class="all-products-item"
                      :href="item.link" :target="item.external ? '_blank' : undefined"
                      :rel="item.external ? 'noopener noreferrer' : undefined"
                      @click="goToProductPage(item, $event)">
                      <div class="all-products-item-info">
                        <div class="all-products-item-head">
                          <span class="all-products-item-title">{{ item.name }}</span>
                          <span v-if="item.current" class="all-products-item-badge">当前使用</span>
                        </div>
                        <p class="all-products-item-desc">{{ item.desc }}</p>
                      </div>
                      <img src="@/assets/images/all-product/all-right.png" alt="前往" class="all-products-item-arrow">
                    </a>
                  </div>
                </transition>
              </div>

              <div class="header-nav-action" @click="openConsultModal">
                <img
                  :src="require('@/assets/images/M-11console.png')"
                  class="header-nav-action__img header-nav-action__img--consult"
                  alt="商务咨询"
                >
              </div>

              <div class="header-nav-action" @click="showCustomerService">
                <img :src="require('../../assets/images/kefu.png')" class="header-nav-action__img" alt="客服">
                <label>客服</label>
              </div>

              <div class="loginViewStyle" v-if="!userInfo" style="margin-left: 20px;" @click="showLogin">
                <label>登录/注册</label>
              </div>
              <div v-else
                class="header-user-block"
                @mouseenter="handleAvatarMouseEnter" @mouseleave="handleAvatarMouseLeave" @click="togglePopup">
                <img :src="userAvatar" alt="用户头像"
                  style="width: 32px; height: 32px; border-radius: 50%; object-fit: cover; flex-shrink: 0;">
                <label
                  style="font-family: PingFang SC, PingFang SC; font-weight: 500; font-size: 12px; color: #E4E4E1; text-align: left; font-style: normal; text-transform: none; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex-shrink: 0; cursor: pointer;"
                  @click.stop="handleLogout">退出</label>

                <!-- 用户信息悬停弹窗 -->
                <div v-if="showUserPopup" class="user-popup"
                  style="position: absolute; top: 100%; right: 0; margin-top: 13px; z-index: 10005;"
                  @mouseenter="handlePopupMouseEnter" @mouseleave="handlePopupMouseLeave">
                  <!-- 第一个模块：用户信息 -->
                  <div class="popup-module user-info-module">
                    <div class="user-avatar-section">
                      <img :src="userAvatar" alt="用户头像" class="popup-avatar" @click="goToMessagePage">
                    </div>
                    <div class="user-text-section">
                      <div class="user-name-row" @click="goToMessagePage">
                        <span class="user-name">{{ userNickName }}</span>
                        <img :src="require('@/assets/images/M-1301.png')" alt="等级图标" class="level-icon">
                      </div>
                      <div class="user-id-row">
                        <span class="user-id" @click="goToMessagePage">ID:{{ userId }}</span>
                        <div class="vertical-separator"></div>
                        <span class="logout-text" @click="handleLogout">退出</span>
                      </div>
                    </div>
                  </div>

                  <!-- 第二个模块：VIP信息 -->
                  <div class="popup-module vip-module">
                    <div class="vip-background">
                      <div v-if="memberInfo.levelId == 2" class="vip-bg-image">
                        <img :src="require('@/assets/images/vip-2.png')" alt="VIP背景" style="width: 100%; height: 100%;">
                      </div>
                      <div v-else-if="memberInfo.levelId == 3" class="vip-bg-image">
                        <img :src="require('@/assets/images/vip-3.png')" alt="VIP背景" style="width: 100%; height: 100%;">
                      </div>
                      <div v-else-if="memberInfo.levelId == 4" class="vip-bg-image">
                        <img :src="require('@/assets/images/vip-4.png')" alt="VIP背景" style="width: 100%; height: 100%;">
                      </div>

                      <div v-if="memberInfo.levelId == 2" class="vip-left" style="bottom: 30px;">
                        <div style="font-weight: 500;font-size: 15px;color: #1A1408;">免费会员</div>
                      </div>
                      <div v-if="memberInfo.levelId == 3" class="vip-left" style="bottom: 30px;">
                        <div style="font-weight: 500;font-size: 15px;color: #1A1408;">个人VIP</div>
                      </div>
                      <div v-if="memberInfo.levelId == 4" class="vip-left" style="bottom: 30px;">
                        <div style="font-weight: 500;font-size: 15px;color: #1A1408;">企业VIP</div>
                      </div>

                      <div class="vip-left" v-if="memberInfo.levelId != 2">
                        <div class="vip-expire">有效期：{{ formatVipExpiryDate(memberInfo.expiryDate) }}</div>
                      </div>
                      <div class="vip-left" v-if="memberInfo.levelId == 2">
                        <div class="vip-expire">升级会员尊享特权</div>
                      </div>

                      <div class="vip-right" v-if="memberInfo.levelId == 4">
                        <div class="renewal-btn" @click="openMembershipRenewal">会员续费</div>
                      </div>
                      <div class="vip-right" v-else-if="memberInfo.levelId == 3">
                        <div class="upgrade-btn" @click="openMembershipUpgrade">会员升级</div>
                      </div>
                      <div class="vip-right" v-else-if="memberInfo.levelId == 2">
                        <div class="upgrade-btn" @click="openMembershipUpgrade">升级VIP</div>
                      </div>


                    </div>
                  </div>

                  <!-- 第三个模块：调用次数 -->
                  <div class="popup-module call-counts-module">
                    <div class="call-count-row">
                      <span class="call-label">剩余非视频类可调用次数</span>
                      <span class="call-value">{{ formatAvailableCount(memberInfo.availabeCount) }}</span>
                    </div>
                    <div class="call-count-row">
                      <span class="call-label">剩余视频类可调用时长</span>
                      <span class="call-value">{{ formatAvailableTime(memberInfo.availabeTime) }}</span>
                    </div>
                  </div>

                  <!-- 水平分割线 -->
                  <div class="horizontal-separator"></div>

                  <!-- 第四个模块：进入主页 -->
                  <div class="popup-module homepage-module" @click="goToUserHomepage" :title="getHomepageTooltip()">
                    <div class="homepage-content">
                      <span class="homepage-text">进入我的主页</span>
                      <div class="homepage-info" v-if="userInfo">
                        <div class="homepage-status">
                          <span :class="['status-dot', getUserStatus().type]"></span>
                          <span class="status-text">{{ getUserStatus().text }}</span>
                          <img :src="require('@/assets/images/M-1103.png')" alt="箭头" class="arrow-icon">
                        </div>
                        <div class="visit-count" v-if="homepageVisitHistory.length > 0">
                          <span class="count-text">访问 {{ homepageVisitHistory.length }} 次</span>
                          <span class="last-visit" v-if="homepageVisitHistory[0]">
                            {{ formatLastVisitTime(homepageVisitHistory[0].visitTime) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </el-header>

      <!-- 主要内容 -->
      <el-main class="main-content">
        <router-view />

      </el-main>

      <!-- 页脚区域 -->
      <footer class="footer">
        <div class="footer-content">
          <!-- 左侧：联系我们 -->
          <div class="footer-left">
            <h3 class="footer-title">联系我们</h3>
            <div class="footer-contact-item">
              <span class="footer-text">数字产线官网： </span>
              <a href="https://www.degeline.com" target="_blank" class="footer-link">https://www.degeline.com</a>
            </div>
            <div class="footer-contact-item">
              <span class="footer-text">富统信息官网： </span>
              <a href="https://www.futoit.com" target="_blank" class="footer-link">https://www.futoit.com</a>
            </div>
            <div class="footer-contact-item">
              <span class="footer-text">邮箱咨询： </span>
              <a href="mailto:hq@futoit.com" class="footer-link">hq@futoit.com</a>
            </div>
            <div class="footer-contact-item">
              <span class="footer-text">商务合作电话/微信： </span>
              <span class="footer-phone">18019767760</span>
            </div>
          </div>

          <!-- 中间：关注数字产线 -->
          <div class="footer-middle">
            <h3 class="footer-title">关注数字产线</h3>
            <p class="footer-description">关注数字产线公众号和服务号或扫码小程序，了解更多AI智能体功能，添加企微一对一咨询解答</p>
            <div class="qr-codes-container">
              <div class="qr-code-item">
                <img src="@/assets/images/M-2001.png" alt="公众号" class="qr-code-image">
                <span class="qr-code-label">公众号</span>
              </div>
              <div class="qr-code-item">
                <img src="@/assets/images/M-2002.png" alt="服务号" class="qr-code-image">
                <span class="qr-code-label">服务号</span>
              </div>
              <div class="qr-code-item">
                <img src="@/assets/images/M-2003.png" alt="微信小程序" class="qr-code-image">
                <span class="qr-code-label">微信小程序</span>
              </div>
              <div class="qr-code-item">
                <img src="@/assets/images/M-2004.png" alt="企业微信" class="qr-code-image">
                <span class="qr-code-label">企业微信</span>
              </div>
            </div>
          </div>

          <!-- 右侧：查看作品和店铺 -->
          <div class="footer-right">
            <!-- 查看作品 -->
            <div class="footer-works-section">
              <h3 class="footer-title">在以下平台搜索“数字产线”查看我们的作品</h3>
              <div class="platform-icons-container">
                <div class="platform-icon-item">
                  <img src="@/assets/images/M-2005.png" alt="抖音" class="platform-icon">
                </div>
                <div class="platform-icon-item">
                  <img src="@/assets/images/M-2006.png" alt="小红书" class="platform-icon">
                </div>
                <div class="platform-icon-item">
                  <img src="@/assets/images/M-2007.png" alt="bilibili" class="platform-icon">
                </div>
                <div class="platform-icon-item">
                  <img src="@/assets/images/M-2008.png" alt="快手" class="platform-icon">
                </div>
                <div class="platform-icon-item">
                  <img src="@/assets/images/M-2009.png" alt="微信视频号" class="platform-icon">
                </div>
                <div class="platform-icon-item">
                  <img src="@/assets/images/M-2010.png" alt="微博" class="platform-icon">
                </div>
              </div>
            </div>

            <!-- 查看店铺 -->
            <div class="footer-store-section">
              <h3 class="footer-title">在以下平台搜索“数字产线”查看我们的店铺商品</h3>
              <div class="platform-icons-container">
                <div class="platform-icon-item">
                  <img src="@/assets/images/M-2011.png" alt="淘宝" class="platform-icon">
                </div>
                <div class="platform-icon-item">
                  <img src="@/assets/images/M-2012.png" alt="京东" class="platform-icon">
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部版权信息 -->
        <div class="footer-bottom">
          <div class="footer-logo">
            <img src="@/assets/images/logo.png" alt="Logo" class="logo-image">
          </div>
          <div class="footer-copyright">
            2025 数字产线 CopyRight @富统（上海）信息技术有限公司 All rights reserved by Futong IT Service Co.,Ltd
          </div>
          <div class="footer-icp">
             <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备19036998号-5</a>
          </div>
        </div>
      </footer>
    </el-container>

    <!-- 登录/注册弹窗 -->
    <div v-if="loginVisible" class="login-overlay" @click="closeLoginModal">
      <div class="login-modal" @click.stop>
        <!-- 第一模块：标题和图片 -->
        <div class="login-header">
          <h2 class="login-title">登录</h2>
          <div class="login-image-container">
            <img :src="require('@/assets/images/M-1201.png')" alt="登录图片" class="login-image">
          </div>
        </div>

        <!-- 第二模块：输入框 -->
        <div class="login-form">
          <div class="form-group">
            <label class="form-label">手机号</label>
            <input v-model="loginForm.phone" type="tel" class="form-input phone-input" placeholder="请输入手机号"
              maxlength="11">
          </div>

          <div class="form-group">
            <label class="form-label">验证码</label>
            <div class="verification-container">
              <input v-model="loginForm.verificationCode" type="text" class="form-input verification-input"
                placeholder="请输入验证码" maxlength="6">
              <button class="get-code-btn" @click="getVerificationCode" :disabled="countdown > 0">
                {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
              </button>
            </div>
            <!-- <div class="form-tip">提示：验证码功能开发中，请输入任意6位数字即可</div> -->
          </div>
        </div>

        <!-- 第三模块：登录按钮和注册链接 -->
        <div class="login-footer">
          <button class="login-btn" @click="handleLogin">登录</button>
          <div class="register-link">
            <span class="register-text">还没有账号？</span>
            <span class="register-action" @click="goToRegister">立即注册</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 注册弹窗 -->
    <div v-if="registerVisible" class="register-overlay" @click="closeRegisterModal">
      <div class="register-modal" @click.stop>
        <!-- 第一模块：标题和图片 -->
        <div class="register-header">
          <h2 class="register-title">注册</h2>
          <div class="register-image-container">
            <img :src="require('@/assets/images/M-1201.png')" alt="注册图片" class="register-image">
          </div>
        </div>

        <!-- 第二模块：输入框 -->
        <div class="register-form">
          <div class="form-group">
            <label class="form-label">
              手机号 <span class="required-star">*</span>
            </label>
            <input v-model="registerForm.phone" type="tel" class="form-input phone-input" placeholder="请输入手机号"
              maxlength="11">
          </div>

          <div class="form-group">
            <label class="form-label">
              验证码 <span class="required-star">*</span>
            </label>
            <div class="verification-container">
              <input v-model="registerForm.verificationCode" type="text" class="form-input verification-input"
                placeholder="验证码功能开发中，请输入任意6位数字" maxlength="6">
              <button class="get-code-btn" @click="getRegisterVerificationCode" :disabled="registerCountdown > 0">
                {{ registerCountdown > 0 ? `${registerCountdown}s` : '获取验证码' }}
              </button>
            </div>
            <div class="form-tip">提示：验证码功能开发中，请输入任意6位数字即可</div>
          </div>

          <div class="form-group">
            <label class="form-label">
              邀请码 <span class="optional-text">(可选)</span>
            </label>
            <input v-model="registerForm.invitationCode" type="text" class="form-input invitation-input"
              placeholder="请输入邀请码 (选填)">
          </div>

          <div class="agreement-container">
            <input type="checkbox" v-model="registerForm.agreement" class="agreement-checkbox" id="agreement">
            <label for="agreement" class="agreement-text">
              阅读并同意
            </label>
            <span class="agreement-link" @click="showAgreementDialog">《用户协议》</span>
          </div>
        </div>

        <!-- 第三模块：注册按钮和登录链接 -->
        <div class="register-footer">
          <button class="register-btn" @click="handleRegisterSubmit">注册</button>
          <div class="login-link">
            <span class="login-text">已有账号？</span>
            <span class="login-action" @click="goToLogin">立即登录</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 会员升级弹窗 -->
    <div v-if="showMembershipUpgrade" class="membership-upgrade-overlay" @click="showMembershipUpgrade = false">
      <div class="membership-upgrade-modal" @click.stop>
        <!-- 第一个模块：金色头部 -->
        <div class="membership-header">
          <div class="membership-header-left">
            <div class="user-avatar-section">
              <img :src="userAvatar" alt="用户头像" class="membership-avatar">
            </div>
            <div class="account-info">
              <span class="account-text">充值账号：{{ userNickName }}</span>
              <span class="expiry-text" v-if="memberInfo.vipExpiryDate && memberInfo.levelId != 2">
                有效期至：{{ formatVipExpiryDate(memberInfo.expiryDate) }}
              </span>
              <span class="expiry-text" v-else>
                升级会员尊享特权
              </span>
            </div>
          </div>
          <div class="membership-header-right">
            <div class="privileges-title">开通会员尊享特权</div>
            <div class="privileges-list">
              <div class="privilege-item">
                <img :src="require('@/assets/images/M-1403.png')" alt="自定义数字人模板" class="privilege-icon">
                <span class="privilege-text">自定义数字人模板</span>
              </div>
              <div class="privilege-item">
                <img :src="require('@/assets/images/M-1402.png')" alt="AI工具" class="privilege-icon">
                <span class="privilege-text">更丰富的AI提效工具</span>
              </div>
              <div class="privilege-item">
                <img :src="require('@/assets/images/M-1401.png')" alt="优先生成" class="privilege-icon">
                <span class="privilege-text">优先生成作品</span>
              </div>
              <div class="privilege-item">
                <img :src="require('@/assets/images/M_0006.png')" alt="额外流量" class="privilege-icon">
                <span class="privilege-text">每月获取额外流量</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 第二个模块：VIP计划和支付 -->
        <div class="membership-content">
          <!-- 第一部分：VIP计划选择 -->
          <div class="vip-plans-section">
            <div class="vip-plan-card" :class="{ 'selected': selectedVipPlan === 'personal' }"
              @click="selectVipPlan('personal')">
              <div class="plan-title">{{ personalVipData ? personalVipData.levelName : '个人VIP' }}</div>
              <div class="plan-subtitle">适用于个人使用</div>
              <div class="plan-price">
                <span class="price-number">{{ personalVipData ? personalVipData.monthlyCost : '199' }}</span>
                <span class="price-unit">{{
                  personalVipData ? (personalVipData.validMonth === 12 ? '元/年' : '元/月') : '元/年'
                }}</span>
              </div>
              <div class="plan-divider">
                <div class="divider-line"></div>
                <span class="divider-text">尊享权益</span>
                <div class="divider-line"></div>
              </div>
              <div class="plan-benefits">
                <div v-if="personalVipData">
                  <div class="benefit-item">
                    <span>非视频类可调用次数</span>
                    <span>{{ personalVipData.monthlyUsage === -1 ? '不限次数' : personalVipData.monthlyUsage + '次' }}</span>
                  </div>
                  <div class="benefit-item">
                    <span>视频类可调用时长</span>
                    <span>{{ personalVipData.monthlyDuration === -1 ? '不限时长' : personalVipData.monthlyDuration + '分钟'
                      }}</span>
                  </div>
                  <div class="benefit-item">
                    <span>执行优先度</span>
                    <span>{{ personalVipData.executi || '中' }}</span>
                  </div>
                </div>
                <div v-else>
                  <div class="benefit-item">
                    <span>非视频类可调用次数</span>
                    <span>200次</span>
                  </div>
                  <div class="benefit-item">
                    <span>视频类可调用时长</span>
                    <span>200分钟</span>
                  </div>
                  <div class="benefit-item">
                    <span>执行优先度</span>
                    <span>中</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="vip-plan-card" :class="{ 'selected': selectedVipPlan === 'enterprise' }"
              @click="selectVipPlan('enterprise')">
              <div class="plan-title">{{ enterpriseVipData ? enterpriseVipData.levelName : '企业VIP' }}</div>
              <div class="plan-subtitle">适用于小团体或企业使用</div>
              <div class="plan-price">
                <span class="price-number">{{ enterpriseVipData ? enterpriseVipData.monthlyCost : '199' }}</span>
                <span class="price-unit">{{
                  enterpriseVipData ? (enterpriseVipData.validMonth === 12 ? '元/年' : '元/月') : '元/月'
                }}</span>
              </div>
              <div class="plan-divider">
                <div class="divider-line"></div>
                <span class="divider-text">尊享权益</span>
                <div class="divider-line"></div>
              </div>
              <div class="plan-benefits">
                <div v-if="enterpriseVipData">
                  <div class="benefit-item">
                    <span>非视频类可调用次数</span>
                    <span>{{ enterpriseVipData.monthlyUsage === -1 ? '不限次数' : enterpriseVipData.monthlyUsage + '次'
                      }}</span>
                  </div>
                  <div class="benefit-item">
                    <span>视频类可调用时长</span>
                    <span>{{ enterpriseVipData.monthlyDuration === -1 ? '不限时长' : enterpriseVipData.monthlyDuration +
                      '分钟' }}</span>
                  </div>
                  <div class="benefit-item">
                    <span>执行优先度</span>
                    <span>{{ enterpriseVipData.executi || '高' }}</span>
                  </div>
                </div>
                <div v-else>
                  <div class="benefit-item">
                    <span>非视频类可调用次数</span>
                    <span>不限次数</span>
                  </div>
                  <div class="benefit-item">
                    <span>视频类可调用时长</span>
                    <span>不限时长</span>
                  </div>
                  <div class="benefit-item">
                    <span>执行优先度</span>
                    <span>高</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 分隔线 -->
          <div class="content-separator"></div>

          <!-- 第二部分：支付方式选择 -->
          <div class="payment-section">
            <div class="payment-container">
              <!-- 二维码和支付方式 -->
              <div class="qr-payment-row">
                <div class="qr-code-section">
                  <div v-if="qrCodeLoading && selectedPaymentMethod !== 'alipay'" class="qr-loading">
                    <div class="loading-spinner"></div>
                    <span>加载中...</span>
                  </div>

                  <img v-else-if="memberRechargeQRCode && selectedPaymentMethod !== 'alipay'"
                    :src="memberRechargeQRCode" alt="充值二维码" class="qr-code" @error="handleQRCodeError">
                  <img v-else-if="selectedPaymentMethod !== 'alipay'" :src="require('@/assets/images/M-1407.png')"
                    alt="默认二维码" class="qr-code">

                  <!-- 错误信息显示 -->
                  <div v-if="qrCodeError && selectedPaymentMethod !== 'alipay'"
                    style="margin-top: 10px; padding: 8px 12px; background: rgba(255, 107, 107, 0.1); border: 1px solid #ff6b6b; border-radius: 6px; color: #ff6b6b; font-size: 14px;">
                    {{ qrCodeError }}
                  </div>

                  <!-- 支付服务不可用提示 -->
                  <div v-if="showPaymentServiceUnavailable && selectedPaymentMethod !== 'alipay'"
                    style="margin-top: 15px; padding: 15px; background: rgba(255, 107, 107, 0.1); border: 1px solid #ff6b6b; border-radius: 8px; color: #fff;">
                    <div style="font-weight: bold; margin-bottom: 10px; color: #ff6b6b;">⚠️ 支付服务暂时不可用</div>
                    <div style="margin-bottom: 10px; font-size: 14px;">
                      由于服务器端支付服务出现异常，暂时无法生成支付二维码。
                    </div>
                    <div style="margin-bottom: 15px; font-size: 14px;">
                      <strong>建议解决方案：</strong>
                      <ul style="margin: 8px 0; padding-left: 20px;">
                        <li>稍后再试（支付服务可能已恢复）</li>
                        <li><span class="contact-link" @click="contactCustomerService">联系客服获取帮助</span></li>
                        <li>检查网络连接是否正常</li>
                      </ul>
                    </div>

                  </div>

                </div>

                <!-- 右侧支付方式和应付金额 -->
                <div class="payment-right-section">

                  <label class="payment-method">
                    <input type="radio" value="wechat" v-model="selectedPaymentMethod"
                      @change="selectPaymentMethod('wechat')">
                    <img :src="require('@/assets/images/M-1409.png')" alt="微信" class="payment-icon">
                    <span class="payment-text">微信支付</span>
                  </label>

                  <label class="payment-method">
                    <input type="radio" value="alipay" v-model="selectedPaymentMethod"
                      @change="selectPaymentMethod('alipay')">
                    <img :src="require('@/assets/images/M-1410.png')" alt="支付宝" class="payment-icon">
                    <span class="payment-text">支付宝支付</span>
                  </label>

                  <div class="amount-section">
                    <span class="amount-label">应付金额：</span>
                    <span class="amount-value">￥{{ getSelectedVipPrice() }}</span>
                    <button v-if="selectedPaymentMethod === 'alipay'" class="pay-now-btn" @click="handlePayNow"
                      :disabled="qrCodeLoading">
                      立即支付
                    </button>
                  </div>
                </div>
              </div>

              <!-- 第四行：温馨提示标题 -->
              <div class="tips-title">温馨提示：</div>

              <!-- 第五行：温馨提示内容 -->
              <div class="tips-content">
                <div class="tip-item">1、充值后不支持退款，请试用满意后再购买(虚拟产品不支持退款）。</div>
                <div class="tip-item">2、若开通会员后10分钟内会员仍然没有到账，请在个人中心页面点击刷新会员，或者<span class="contact-link"
                    @click="contactCustomerService">联系客服>></span></div>
                <div class="tip-item">3、如有其他疑问，请<span class="contact-link" @click="contactCustomerService">联系客服>></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 客服弹窗 -->
    <div v-if="showCustomerServicePopup" class="customer-service-overlay" @click="closeCustomerService">
      <div class="customer-service-modal" @click.stop>
        <!-- 第一模块：标题栏 -->
        <div class="customer-service-header">
          <img :src="require('@/assets/images/M-1502.png')" alt="客服图标" class="service-icon">
          <span class="service-title">联系客服</span>
        </div>

        <!-- 第二模块：二维码和说明 -->
        <div class="customer-service-content">
          <div class="qr-section">
            <div class="qr-row">
              <img :src="require('@/assets/images/M-1504.png')" alt="扫描图标" class="scan-icon">
              <span class="scan-text">扫描二维码添加客服微信</span>
            </div>
            <div class="working-hours">工作时间：周一至周五 9:00-18:00</div>
            <div class="qr-code-container">
              <img :src="require('@/assets/images/M-1503.png')" alt="客服二维码" class="qr-code">
            </div>
          </div>

          <!-- 第三模块：微信号和备注 -->
          <!-- <div class="wechat-section">
            <div class="wechat-row">
              <span class="wechat-label">客服微信号：digital_factory</span>
              <img :src="require('@/assets/images/M-1505.png')" alt="复制图标" class="copy-icon" @click="copyWechatId">
            </div>
            <div class="note-text">添加时请备注：数字产线用户</div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- 留言咨询 / 商务洽谈留资弹窗：POST /manage/leadinquiries -->
    <div
      v-if="showConsultModal"
      class="consult-modal-mask"
    >
      <div class="consult-modal" role="dialog" aria-modal="true" aria-labelledby="consult-modal-title">
        <button
          type="button"
          class="consult-modal-close"
          aria-label="关闭"
          @click="closeConsultModal"
        >
          ×
        </button>
        <div class="consult-modal-inner">
          <header class="consult-modal-head">
            <h2 id="consult-modal-title" class="consult-modal-title">
              商务洽谈/咨询，请留资
            </h2>
            <p class="consult-modal-subtitle">
              填写信息，专属顾问为您一对一解答，全程免费无骚扰
            </p>
          </header>
          <div class="consult-modal-form">
            <div class="consult-field-group">
              <label class="consult-label" for="consult-nickname">您的称呼（选填）</label>
              <input
                id="consult-nickname"
                v-model="consultForm.nickname"
                type="text"
                class="consult-field"
                placeholder="请填写您的称呼 (选填)"
                autocomplete="name"
              >
            </div>
            <div class="consult-field-group">
              <label class="consult-label" for="consult-phone">手机号码</label>
              <input
                id="consult-phone"
                v-model="consultForm.phone"
                type="tel"
                class="consult-field"
                placeholder="方便我们为您回电解答"
                autocomplete="tel"
              >
            </div>
            <div class="consult-field-group">
              <label class="consult-label" for="consult-email">邮箱地址</label>
              <input
                id="consult-email"
                v-model="consultForm.email"
                type="email"
                class="consult-field"
                placeholder="可接收我们的资料 / 回复"
                autocomplete="email"
              >
            </div>
            <div class="consult-field-group">
              <label class="consult-label" for="consult-interest">您想了解的内容</label>
              <div class="consult-select-wrap">
                <select
                  id="consult-interest"
                  v-model="consultForm.interest"
                  class="consult-field consult-field--select"
                  :class="{ 'consult-field--muted': !consultForm.interest }"
                >
                  <option value="" disabled>选择您感兴趣的功能/业务</option>
                  <option v-for="opt in consultInterestOptions" :key="opt" :value="opt">
                    {{ opt }}
                  </option>
                </select>
              </div>
            </div>
            <div class="consult-field-group">
              <label class="consult-label" for="consult-city">所在城市（选填）</label>
              <input
                id="consult-city"
                v-model="consultForm.city"
                type="text"
                class="consult-field"
                placeholder="请输入所在城市"
                autocomplete="address-level2"
              >
            </div>
            <div class="consult-field-group">
              <label class="consult-label" for="consult-remark">其他说明</label>
              <textarea
                id="consult-remark"
                v-model="consultForm.remark"
                class="consult-field consult-field--textarea"
                rows="3"
                placeholder="还有其他疑问或需求？请告诉我们"
              ></textarea>
            </div>
          </div>
          <footer class="consult-modal-footer">
            <button
              type="button"
              class="consult-submit-btn"
              :disabled="consultSubmitting"
              @click="submitConsultForm"
            >
              {{ consultSubmitting ? '提交中…' : '提交表单' }}
            </button>
          </footer>
        </div>
      </div>
    </div>

    <!-- 支付跳转弹窗 -->
    <div v-if="showPaymentRedirectDialog" class="payment-redirect-overlay" @click="closePaymentRedirectDialog">
      <div class="payment-redirect-modal" @click.stop>
        <div class="payment-redirect-header">
          <span class="payment-redirect-title">支付信息</span>
          <button class="payment-redirect-close" @click="closePaymentRedirectDialog">×</button>
        </div>
        <div class="payment-redirect-content">
          <iframe :srcDoc="pageRedirectionData" style="width: 100%; height: 100%; border: none;">
          </iframe>
        </div>
      </div>
    </div>

    <!-- 用户协议弹窗 -->
    <el-dialog title="用户协议" :visible.sync="agreementDialogVisible" width="80%" :before-close="closeAgreementDialog"
      class="agreement-dialog">
      <div class="agreement-content">
        <div class="agreement-section">
          <h3>一、总则</h3>
          <p>1、用户在注册及使用前请认真阅读本协议，确保充分理解本协议中所有条款。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。您的注册、登录、使用等行为将视为无条件接受本协议所有条款的约束。</p>
          <p>2、除非另有明确规定，本产品所推出的新功能、新服务，均无条件的使用本协议。</p>
          <p>3、我公司保留在任何时候修改本协议条款的权利，且无需另行通知。在我公司修改协议条款后，如果您不接受修改后的条款，请立即停止使用本产品提供的服务，继续使用本产品提供的服务将被视为接受修改后的协议。</p>
        </div>

        <div class="agreement-section">
          <h3>二、用户注册</h3>
          <p>1、用户应当同意本协议的全部条款并按照页面提示完成全部注册程序(未成年人应与法定监护人共同完成)。用户在注册过程中点击"下一步"按钮即表示完全接受本协议全部条款。</p>
          <p>
            2、用户在使用本服务前需要注册一个本产品账号。本产品账号应当使用手机号码绑定注册，请用户使用尚未与本产品账号绑定且未被本产品根据本协议封禁的手机号码注册账号。本产品可以根据用户需求或产品需求对账号注册和绑定的方式进行更改，而无须事先通知用户。
          </p>
          <p>3、用户在使用本产品服务过程中应保证各项服务业务所需信息的真实性，如果因信息不真实而引起的问题，以及问题发生所带来的后果，本公司不负任何责任。</p>
          <p>
            4、在用户注册及使用本产品时，要搜集能识别用户身份的个人信息以便系统可以在必要时联系用户，或为用户提供更好的使用体验。系统搜集的信息包括但不限于用户的性别、年龄、出生日期、所在城市；系统同意对这些信息的使用将受限于用户个人隐私信息保护的约束。
          </p>
        </div>

        <div class="agreement-section">
          <h3>三、服务内容</h3>
          <p>1、本服务的具体内容由本产品根据实际情况提供，包括但不限于用户使用本产品等。本产品可以对提供的服务予以变更，且本产品提供的服务内容可能随时变更，用户将会收到关于服务变更的通知。</p>
          <p>2、除非本协议另有其他明示规定，本公司所推出的新产品、新功能、新服务，均受到本协议条款之规范。</p>
        </div>

        <div class="agreement-section">
          <h3>四、服务变更、中断或终止</h3>
          <p>1、鉴于网络服务的特殊性(包括但不限于服务器的稳定性问题、恶意的网络攻击等行为的存在及其他无法控制的情形)，用户同意我公司有权随时中断或终止部分或全部的服务。</p>
          <p>2、我公司需要定期或不定期地对提供服务的系统或相关设备进行检修或维护，如因此类情况而造成服务在合理时间内的中断，我公司无需为此承担任何责任。</p>
          <p>3、如发生下列任何一种情形，我公司有权随时变更、中断或终止向用户提供本协议项下的服务而无需对用户或任何第三方承担任何责任：</p>
          <ul>
            <li>根据法律规定用户应提交真实信息，而用户提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；</li>
            <li>用户违反相关法律法规或本协议的约定；</li>
            <li>按照法律规定或有权机关的要求；</li>
            <li>出于安全的原因或其他必要的情形。</li>
          </ul>
        </div>

        <div class="agreement-section">
          <h3>五、用户个人隐私信息保护</h3>
          <p>1、依据法律的规定，我们将在特定情形下收集、使用和披露您的个人信息。以下条款描述了我们如何收集、使用和披露您的个人信息。</p>
          <p>2、信息收集</p>
          <p>
            (1)用户提供：我们会对您直接提供的信息进行保存。比如：我们会记录您的注册信息、寻求客服或者其他和我们沟通的记录。记录信息的种类包括：头像、昵称、性别、出生日期、所在地区以及其他您选择提供的信息。我们收集、使用和披露个人信息是为了通过创建账户、识别用户、回应查询和邮件等方式来为您提供服务。
          </p>
          <p>
            当你接触或者使用我们的服务时，我们将自动收集您的信息包括：Log信息(我们记录所有您使用服务时的log信息，包括浏览器信息、使用时间、浏览的网页、IP地址及来源)。我们使用多种技术记录信息，包括但不限于：向您的移动设备种Cookies。Cookies是一些存在您的硬件上的小数据包，用以帮助我们提高服务的质量及您的使用体验，了解在哪些区域和功能上受欢迎，以及统计流量等。
          </p>
        </div>

        <div class="agreement-section">
          <h3>六、内容规范</h3>
          <p>
            1、本项规范所述内容是指用户使用本服务过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、名称、个性签名等注册信息及认证资料，或文字、语音、图片、图文等发送、回复消息和相关链接页面，以及其他使用本产品账号或本服务所产生的内容。
          </p>
          <p>2、用户承诺使用本产品的服务时必须符合中华人民共和国有关法律法规，不得利用本产品的服务制作、上载、复制、发布、传播以下内容：</p>
          <ul>
            <li>反对宪法所确定的基本原则的；</li>
            <li>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
            <li>损害国家荣誉和利益的；</li>
            <li>煽动民族仇恨、民族歧视，破坏民族团结的；</li>
            <li>破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
            <li>散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
            <li>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
            <li>侮辱或者诽谤他人，侵害他人合法权益的；</li>
            <li>含有法律、行政法规禁止的其他内容的。</li>
          </ul>
        </div>

        <div class="agreement-section">
          <h3>七、使用规则</h3>
          <p>1、用户在本服务中或通过本服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表我公司的观点、立场或政策，我公司对此不承担任何责任。</p>
          <p>2、用户在使用本产品时，必须遵守中华人民共和国相关法律法规的规定，同意将不会利用本产品进行任何违法或不正当的活动，包括但不限于下列行为：</p>
          <ul>
            <li>干扰或破坏有关服务，或与有关服务连接的任何服务器或网络，或与有关服务相关的任何政策、要求或规定；</li>
            <li>采集并存储涉及任何其他用户的个人信息，以用于任何被禁止的活动；</li>
            <li>故意或非故意违反任何相关的中国法律、法规、规章、条例等其他具有法律效力的规范。</li>
          </ul>
        </div>

        <div class="agreement-section">
          <h3>八、免责声明</h3>
          <p>
            1、对于经由本产品服务而传送的内容，我公司不保证前述内容的正确性、完整性或品质。用户在接受有关服务时，有可能会接触到令人不快、不适当或令人厌恶的内容。在任何情况下，我公司均不对任何内容负责，包括但不限于任何内容发生任何错误或纰漏以及衍生的任何损失或损害。用户使用上述内容，应自行承担风险。
          </p>
          <p>2、用户明确同意其使用本产品所存在的风险及其后果将完全由其自己承担，我公司对用户不承担任何责任。如因用户违反有关法律、法规或本协议项下的任何条款而给任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。
          </p>
          <p>3、我公司尊重并保护用户的个人隐私权。但因恶意的网络攻击等行为及其他无法控制的情形，导致用户隐私信息泄露的，用户同意我公司不承担任何责任。</p>
          <p>4、对于因电信系统或互联网网络故障、计算机故障、计算机系统问题或其它任何不可抗力原因而产生损失，我公司不承担任何责任，但将尽力减少因此给用户造成的损失和影响。</p>
        </div>

        <div class="agreement-section">
          <h3>九、知识产权声明</h3>
          <p>
            1、本产品服务中包含的任何文字、图表、音频、视频和软件(包括但不限于软件中包含的图表、动画、音频、视频、界面实际、数据和程序、代码、文档)等信息或材料均受著作权法、商标法和其它法律法规保护，未经相关权利人书面同意，用户不得以任何方式使用该信息或材料。
          </p>
          <p>2、本协议未授予用户使用本产品任何商标、服务标记、标识、域名和其他显著品牌特征的权利，任何人不得擅自(包括但不限于：以非法的方式复制、传播、展示、镜像、上载、下载)使用，否则我公司将依法追究法律责任。</p>
          <p>3、除本协议明确允许以外，用户不得以任何形式或任何方式对本产品部分或全部内容进行修改、出租、租赁、出借、出售、分发、复制、创作衍生品或用于任何商业用途。</p>
        </div>

        <div class="agreement-section">
          <h3>十、法律适用</h3>
          <p>1、本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。如服务条款任何一部分与中华人民共和国法律相抵触，则该部分条款应按法律规定重新解释，部分条款无效或重新解释不影响其余条款法律效力。</p>
          <p>2、用户和我公司一致同意本协议。在执行本协议过程中如发生纠纷，双方应友好协商解决；协商不成时，任何一方可直接向我司所在地的人民法院提起诉讼。</p>
        </div>

        <div class="agreement-section">
          <h3>十一、其他规定</h3>
          <p>1、本协议中的标题仅为方便而设，在解释本协议时应被忽略。</p>
          <p>2、本协议及其修改权、最终解释权归我公司所有。</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAgreementDialog">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { userApi } from '@/api/index'
import { createLeadInquiry } from '@/api/leadInquiries'
import { tokenUtils } from '@/utils/request'

export default {
  name: 'MainLayout',
  data() {
    return {
      // 用户信息数据
      userProfile: {},
      loading: false,
      error: null,
      userInfo: null,
      showInfo: false,
      showUserPopup: false,
      popupKeepOpen: false, // 添加弹窗保持打开状态
      showMembershipUpgrade: false, // 会员升级弹窗显示状态
      showCustomerServicePopup: false, // 客服弹窗显示状态
      showConsultModal: false,
      consultSubmitting: false,
      consultInterestOptions: [
        'AI短视频评论推广/弹幕推广',
        'AI企业营销邮件推送',
        '工作流',
        '智能体'
      ],
      consultForm: {
        nickname: '',
        phone: '',
        email: '',
        interest: '',
        city: '',
        remark: ''
      },
      showMarketingPopup: false, // AI企业营销悬停弹窗显示状态
      marketingPopupTimer: null, // AI企业营销弹窗关闭定时器
      showAllProductsPopup: false, // 全部产品下拉弹窗显示状态
      // 全部产品弹窗数据：external 为 true 时新窗口打开，否则走站内路由
      allProductList: [
        { name: '数漫产线', desc: 'AI短剧、广告片承制与图片制作', current: false, link: 'https://dmaline.com/', external: true },
        { name: '数字产线', desc: '工作流、智能体定制与企业营销', current: true, link: '/', external: false },
        { name: '数创产线', desc: 'AI视频、广告复刻与笔记批量生成', current: false, link: 'https://vdoline.com/', external: true },
        { name: '租达人', desc: '一站式达人派单营销平台', current: false, link: 'https://zudaren.com/', external: true }
      ],
      selectedVipPlan: 'personal', // 选中的VIP计划：personal 或 enterprise
      selectedPaymentMethod: 'wechat', // 选中的支付方式：alipay, wechat, unionpay
      // 会员等级数据
      memberLevels: [],
      personalVipData: null, // 个人VIP数据（数组倒数第二个）
      enterpriseVipData: null, // 企业VIP数据（数组倒数第一个）
      memberRechargeQRCode: null, // 会员充值二维码数据
      qrCodeLoading: false, // 二维码加载状态
      qrCodeError: null, // 二维码错误信息
      showPaymentServiceUnavailable: false, // 显示支付服务不可用提示
      currentOrderId: null, // 当前充值订单ID
      pageRedirectionData: null, // 页面跳转数据
      showPaymentRedirectDialog: false, // 显示支付跳转弹窗
      paymentCheckInterval: null, // 支付状态检查定时器
      paymentCheckCount: 0, // 支付状态检查次数
      isCheckingPayment: false, // 是否正在检查支付状态
      loginVisible: false,
      registerVisible: false,
      loginForm: {
        phone: '',
        verificationCode: ''
      },
      registerForm: {
        phone: '',
        verificationCode: '',
        invitationCode: '',
        agreement: false
      },
      // 用户协议弹窗控制
      agreementDialogVisible: false,
      homepageVisitHistory: [], // 添加访问历史记录
      countdown: 0, // 验证码倒计时
      registerCountdown: 0, // 注册验证码倒计时
      loginRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '验证码为6位数字', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn', 'userAvatar', 'userNickName', 'userId', 'memberInfo']),

    // 获取当前激活的菜单索引
    getActiveMenuIndex() {
      const currentPath = this.$route.path

      // 如果是 avatarflow 相关页面，高亮"高级工作流"
      if (currentPath.startsWith('/avatarflow') || currentPath.startsWith('/addWorkflow')) {
        return '/workflow'
      }

      // 如果是用户主页，高亮"首页"
      if (currentPath.startsWith('/user/home')) {
        return '/'
      }

      // 如果是AI企业营销页面，返回空字符串，让el-menu-item的index="/"不被激活
      if (currentPath === '/aiEnterpriseMarketing') {
        return '/aiEnterpriseMarketing'
      }

      // 如果是首页，返回"/"激活首页
      if (currentPath === '/' || currentPath === '/home') {
        return '/'
      }

      // 其他情况按正常路径匹配
      return currentPath
    }
  },
  async mounted() {
    // 加载访问历史记录
    this.loadHomepageVisitHistory()

    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleGlobalClick)

    // 设置全局调试函数
    this.setupGlobalDebug()

    // 监听window事件，用于显示客服弹窗
    window.addEventListener('show-customer-service', this.handleShowCustomerServiceEvent)

    // 验证和恢复token
    await this.validateAndRecoverToken()

    // 检查是否有本地存储的用户信息
    await this.checkLocalUserInfo()

    // 获取用户信息
    await this.fetchUserProfile()

    // 获取会员等级列表数据
    this.fetchMemberLevels()


    // 监听打开会员升级弹窗事件
    this.$root.$on('open-membership-upgrade', this.handleOpenMembershipUpgrade)

    // 监听显示登录弹窗事件
    this.$root.$on('show-login-dialog', this.showLogin)
  },

  beforeDestroy() {
    // 移除全局点击事件监听器
    document.removeEventListener('click', this.handleGlobalClick)

    // 移除window事件监听器
    window.removeEventListener('show-customer-service', this.handleShowCustomerServiceEvent)

    // 移除全局事件监听器
    this.$root.$off('open-membership-upgrade', this.handleOpenMembershipUpgrade)
    this.$root.$off('show-login-dialog', this.showLogin)

    // 停止支付状态检查
    this.stopPaymentStatusCheck()

    // 清理营销弹窗定时器
    if (this.marketingPopupTimer) {
      clearTimeout(this.marketingPopupTimer)
      this.marketingPopupTimer = null
    }
  },
  watch: {
    // 监听 showMembershipUpgrade 变化
    showMembershipUpgrade(newVal) {
      if (newVal === false) {
        // 当 showMembershipUpgrade 为 false 时，清掉定时器
        this.stopPaymentStatusCheck()
      }
    },
    // 监听 userInfo 变化，确保与 Vuex store 同步
    userInfo: {
      handler(newVal) {
        if (newVal) {
          // 当 userInfo 更新时，同步更新 Vuex store
          this.syncUserInfoToStore(newVal)
        }
      },
      immediate: false,
      deep: true
    },
    // 监听 Vuex store 中的登录状态变化
    isLoggedIn(newVal) {
      if (!newVal && this.userInfo) {
        // 如果退出登录但本地 userInfo 还存在，清空它
        this.userInfo = null
      }
    }
  },
  methods: {
    ...mapActions('user', ['login', 'updateUserAvatar', 'updateUserNickName', 'updateUserId', 'updateMemberInfo']),

    // 显示用户协议弹窗
    showAgreementDialog() {
      this.agreementDialogVisible = true
    },

    // 关闭用户协议弹窗
    closeAgreementDialog() {
      this.agreementDialogVisible = false
    },

    // 格式化日期为北京时间年月日
    formatVipExpiryDate(dateString) {
      console.log('memberInfo:', this.memberInfo)
      console.log('格式化日期为北京时间年月日:', dateString)
      if (!dateString) return ''

      try {

        // 手动解析日期字符串，因为JavaScript将CST解析为UTC-6而不是UTC+8
        // 格式: "Thu Sep 10 14:54:30 CST 2026"
        const dateMatch = dateString.match(/(\w{3})\s+(\w{3})\s+(\d{1,2})\s+(\d{2}):(\d{2}):(\d{2})\s+CST\s+(\d{4})/)

        if (dateMatch) {
          const [, , monthName, day, hour, minute, second, year] = dateMatch

          // 月份名称映射
          const monthMap = {
            'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5,
            'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11
          }

          const month = monthMap[monthName]
          const date = new Date(year, month, parseInt(day), parseInt(hour), parseInt(minute), parseInt(second))


          // 格式化为年月日
          const formattedYear = date.getFullYear()
          const formattedMonth = String(date.getMonth() + 1).padStart(2, '0')
          const formattedDay = String(date.getDate()).padStart(2, '0')


          return `${formattedYear}年${formattedMonth}月${formattedDay}日`
        } else {
          // 如果正则匹配失败，使用原始方法
          const date = new Date(dateString)
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          return `${year}年${month}月${day}日`
        }
      } catch (error) {
        console.error('日期格式化失败:', error)
        return dateString // 如果格式化失败，返回原始字符串
      }
    },

    // 获取用户个人信息
    async fetchUserProfile() {
      try {
        this.loading = true
        this.error = null

        // console.log('开始获取个人信息...')

        // 检查是否有token
        let token = localStorage.getItem('token')
        if (!token) {
          console.log('未找到登录token，尝试从tokenUtils获取')
          // 尝试从tokenUtils获取
          const tokenUtilsToken = tokenUtils.getToken()
          if (tokenUtilsToken) {
            console.log('从tokenUtils找到token:', tokenUtilsToken.substring(0, 20) + '...')
            token = tokenUtilsToken
            localStorage.setItem('token', tokenUtilsToken)
          } else {
            console.log('仍然未找到token，用户可能未登录')
            this.error = '请先登录'
            return
          }
        }



        const response = await userApi.getUserProfile()

        if (response && response.code === 200) {
          this.userProfile = response.data || response


          // 更新Vuex store中的用户信息（全局同步）
          if (this.userProfile.user?.avatar || this.userProfile.user?.avator) {
            const avatarUrl = this.userProfile.user.avatar || this.userProfile.user.avator
            this.updateUserAvatar(avatarUrl)
          } else if (this.userProfile.user) {
            // 如果用户没有头像，设置默认头像
            const defaultAvatar = require('@/assets/images/M-0510user.png')
            this.userProfile.user.avatar = defaultAvatar
            this.updateUserAvatar(defaultAvatar)
            // console.log('为用户信息设置默认头像:', defaultAvatar)
          }

          if (this.userProfile.user?.nickName) {
            this.updateUserNickName(this.userProfile.user.nickName)
          }

          if (this.userProfile.user?.userId || this.userProfile.user?.id) {
            const userId = this.userProfile.user.userId || this.userProfile.user.id
            this.updateUserId(userId)
          }

          // 更新Vuex store中的会员状态（全局同步）
          if (this.userProfile.memberInfo) {
            this.updateMemberInfo(this.userProfile.memberInfo)
          }
        } else {
          this.error = response.msg || '获取个人信息失败'
          console.error('获取个人信息失败:', response)
        }
      } catch (error) {
        console.error('获取个人信息异常:', error)
        this.error = `获取个人信息失败: ${error.message}`
      } finally {
        this.loading = false
      }
    },

    // 获取选中VIP计划的价格
    getSelectedVipPrice() {
      if (this.selectedVipPlan === 'personal' && this.personalVipData) {
        return this.personalVipData.monthlyCost || '199'
      } else if (this.selectedVipPlan === 'enterprise' && this.enterpriseVipData) {
        return this.enterpriseVipData.monthlyCost || '199'
      }
      return '199'
    },

    // 获取会员等级列表
    async fetchMemberLevels() {
      try {
        // console.log('开始获取会员等级列表...')

        const response = await userApi.getMemberLevelList()
        // console.log('获取会员等级列表成功:', response)
        // console.log('完整响应对象:', JSON.stringify(response, null, 2))

        if (response && response.code === 200) {
          this.memberLevels = response.rows || []
          // console.log('会员等级数据:', this.memberLevels)
          // console.log('会员等级数据类型:', typeof this.memberLevels)
          // console.log('会员等级数据长度:', this.memberLevels.length)

          // 打印每个会员等级项的详细信息
          this.memberLevels.forEach((item, index) => {
            // console.log(`会员等级[${index}]:`, item)
            // console.log(`会员等级[${index}] 键名:`, Object.keys(item))
          })

          // 获取个人VIP数据（数组倒数第二个）
          if (this.memberLevels.length >= 2) {
            this.personalVipData = this.memberLevels[this.memberLevels.length - 2]
            // console.log('个人VIP数据:', this.personalVipData)
            // console.log('个人VIP数据键名:', Object.keys(this.personalVipData))
          }

          // 获取企业VIP数据（数组倒数第一个）
          if (this.memberLevels.length >= 1) {
            this.enterpriseVipData = this.memberLevels[this.memberLevels.length - 1]
          }
        } else {
          // console.error('获取会员等级列表失败:', response)
        }
      } catch (error) {
        // console.error('获取会员等级列表异常:', error)
      }
    },

    // 获取会员充值二维码
    async fetchMemberRechargeQRCode() {
      try {
        this.qrCodeLoading = true

        // 准备请求参数
        const requestData = {
          orderName: '',
          orderType: '0', // 会员充值
          payMoney: this.getSelectedVipPrice(), // 使用选中的VIP价格
          payType: this.selectedPaymentMethod === 'alipay' ? '1' : (this.selectedPaymentMethod === 'wechat' ? '0' : '2'), // 微信:0, 支付宝:1, 云闪付:2
          productId: this.selectedVipPlan === 'personal'
            ? (this.personalVipData ? this.personalVipData.id : 0)
            : (this.enterpriseVipData ? this.enterpriseVipData.id : 0),
          levelName: this.selectedVipPlan === 'personal'
            ? (this.personalVipData ? this.personalVipData.levelName : '个人VIP')
            : (this.enterpriseVipData ? this.enterpriseVipData.levelName : '企业VIP'),
          monthlyCost: this.getSelectedVipPrice()
        }

        // 验证关键参数
        if (!requestData.payMoney || requestData.payMoney <= 0) {
          throw new Error('支付金额无效')
        }
        if (!requestData.productId || requestData.productId <= 0) {
          throw new Error('产品ID无效')
        }
        if (!requestData.levelName) {
          throw new Error('等级名称无效')
        }

        // 调用接口获取二维码数据

        // 尝试调用接口，如果失败则重试
        let response = null
        let retryCount = 0
        // const maxRetries = 2
        response = await userApi.getMemberRechargeQRCode(requestData)
        if (response && response.code === 200) {
          // 提取pageRedirectionData字段（支付宝支付跳转数据）
          if (response.data && response.data.pageRedirectionData) {
            this.pageRedirectionData = response.data.pageRedirectionData
            // 如果是支付宝支付，显示跳转弹窗
            if (this.selectedPaymentMethod === 'alipay') {
              this.showPaymentRedirectDialog = true
            }
          }

          // 从接口返回数据中提取token（如果存在）
          let responseToken = null
          let qrCodeUrl = null

          if (response.data) {
            // 尝试获取二维码URL（支持多种字段名）
            if (typeof response.data === 'string') {
              qrCodeUrl = response.data
            } else if (typeof response.data === 'object') {
              // 优先获取base64编码的图片数据
              qrCodeUrl = response.data.barCodeBase64 || response.data.barCode || response.data.bar_code ||
                response.data.qrCode || response.data.qrcode || response.data.qr_code ||
                response.data.imageUrl || response.data.image_url || response.data.url ||
                response.data.qr || response.data.code || response.data.image
              // console.log('从对象获取二维码URL:', qrCodeUrl)
            }
          }

          // 如果接口返回了token，使用该token重新获取数据
          if (responseToken) {
            console.log('使用接口返回的token重新获取数据:', responseToken.substring(0, 50) + '...')

            // 临时设置新token
            const originalToken = localStorage.getItem('token')
            localStorage.setItem('token', responseToken)

            try {
              // 使用新token重新调用接口
              const secondResponse = await userApi.getMemberRechargeQRCode()
              console.log('使用新token获取数据成功:', secondResponse)

              if (secondResponse && secondResponse.code === 200 && secondResponse.data) {
                // 从第二次响应中获取二维码URL
                if (typeof secondResponse.data === 'string') {
                  qrCodeUrl = secondResponse.data
                } else if (typeof secondResponse.data === 'object') {
                  qrCodeUrl = secondResponse.data.qrCode || secondResponse.data.qrcode || secondResponse.data.qr_code ||
                    secondResponse.data.imageUrl || secondResponse.data.image_url || secondResponse.data.url ||
                    secondResponse.data.qr || secondResponse.data.code || secondResponse.data.image
                }
                console.log('从第二次响应获取的二维码URL:', qrCodeUrl)
              }
            } finally {
              // 恢复原始token
              if (originalToken) {
                localStorage.setItem('token', originalToken)
              } else {
                localStorage.removeItem('token')
              }
            }
          }

          // 设置二维码URL
          if (qrCodeUrl) {
            this.$set(this, 'memberRechargeQRCode', qrCodeUrl)
            this.qrCodeError = null // 清除错误信息

            // 从响应中提取订单ID
            let orderId = null
            if (response.data) {
              // 尝试多种可能的字段名
              orderId = response.data.orderId || response.data.order_id || response.data.id ||
                response.data.orderNo || response.data.order_no || response.data.tradeNo ||
                response.data.trade_no || response.data.outTradeNo || response.data.out_trade_no ||
                response.data.transactionId || response.data.transaction_id


            }

            // 如果找到了订单ID，开始支付状态检查
            if (orderId) {
              this.currentOrderId = OffscreenCanvasRenderingContext2D
              this.startPaymentStatusCheck(orderId)
            } else {
              this.$message.warning('订单ID获取失败，无法自动检测支付状态')
            }
          } else {
            this.$set(this, 'memberRechargeQRCode', null)
          }
        } else {
          const errorMsg = response?.msg || response?.message || '接口调用失败'
          const errorCode = response?.code || '未知'

          // 根据错误代码提供不同的提示
          let userFriendlyError = ''
          if (errorCode === 500) {
            userFriendlyError = '支付服务暂时不可用，请稍后再试或联系客服'
          } else if (errorCode === 400) {
            userFriendlyError = '请求参数错误，请检查选择的信息'
          } else if (errorCode === 401) {
            userFriendlyError = '登录已过期，请重新登录'
          } else if (errorCode === 403) {
            userFriendlyError = '权限不足，无法进行此操作'
          } else {
            userFriendlyError = `接口错误 [${errorCode}]: ${errorMsg}`
          }

          this.qrCodeError = userFriendlyError

          // 如果是500错误，显示降级提示
          if (errorCode === 500) {
            this.showPaymentServiceUnavailable = true
          }

          this.$set(this, 'memberRechargeQRCode', null)
        }
      } catch (error) {
        // 设置错误信息
        let errorMsg = '网络异常，请稍后再试'
        if (error.response) {
          errorMsg = error.response.data?.msg || error.response.data?.message || `HTTP错误: ${error.response.status}`
        } else if (error.message) {
          errorMsg = error.message
        }
        this.qrCodeError = errorMsg

        this.$set(this, 'memberRechargeQRCode', null)
      } finally {
        this.qrCodeLoading = false
      }
    },

    // 处理二维码加载错误
    handleQRCodeError() {
      this.memberRechargeQRCode = null
    },

    // 开始支付状态检查
    startPaymentStatusCheck(orderId) {

      // 清除之前的定时器
      if (this.paymentCheckInterval) {
        clearInterval(this.paymentCheckInterval)
      }

      this.paymentCheckInterval = setInterval(async () => {
        try {
          const response = await userApi.checkPaymentStatus(orderId)
          let payStatus = parseInt(response.data.payStatus)
          console.log('Layout支付状态检查响应:', response.data.payStatus)
          if (payStatus !== 0) {
            let status = response.data.payStatus
            this.stopPaymentStatusCheck()
            this.paymentCheckInterval = null
            // 显示支付成功提示
            this.$message.success('充值成功！')
            // 延迟一点时间再处理充值成功，避免接口调用过于频繁
            setTimeout(async () => {
              await this.handleRechargeSuccess()
            }, 1000)
            // 检查各种可能的成功标志字段
          }
        } catch (error) {
          console.error('❌ 支付状态检查失败:', error.message)
        }
      }, 3000) // 每3秒检查一次
    },

    // 停止支付状态检查
    stopPaymentStatusCheck() {
      this.paymentCheckInterval && clearInterval(this.paymentCheckInterval)
      this.paymentCheckInterval = null
      this.paymentCheckCount = 0
      this.isCheckingPayment = false
    },

    // 重新尝试支付
    async retryPayment() {
      this.showPaymentServiceUnavailable = false
      this.qrCodeError = null
      await this.fetchMemberRechargeQRCode()
    },

    // 联系客服
    contactCustomerService() {
      this.showCustomerServicePopup = true
    },

    // 充值成功处理
    async handleRechargeSuccess() {
      try {
        console.log('会员升级充值成功，开始处理...')

        // 1. 短暂延迟后关闭会员升级弹窗
        setTimeout(async () => {
          this.showMembershipUpgrade = false
          // 2. 等待DOM更新
          await this.$nextTick()
          // 3. 调用充值成功接口
          // await this.callRechargeSuccessAPI()
          // 4. 刷新个人信息数据
          await this.refreshPersonalInfo()
          // 5. 重新调用所有相关接口
          // await this.refreshAllData()
          // 6. 触发全局事件，通知其他组件刷新数据
          this.$root.$emit('membership-upgrade-success', {
            timestamp: new Date().getTime(),
            vipPlan: this.selectedVipPlan,
            paymentMethod: this.selectedPaymentMethod
          })

          // 7. 延迟刷新，确保后端数据已更新
          setTimeout(async () => {
            console.log('延迟刷新个人信息...')
            await this.refreshPersonalInfo()
          }, 2000) // 2秒后刷新

          console.log('会员升级充值成功处理完成，已触发全局事件')
        }, 500) // 500ms后关闭弹窗

      } catch (error) {
        console.error('充值成功处理失败:', error)
        // 支付成功但数据同步出现异常，不显示错误提示，避免用户困惑
      }
    },

    // 调用充值成功接口
    async callRechargeSuccessAPI() {
      try {
        console.log('开始调用充值成功接口...')

        // 构建请求数据
        const requestData = {
          vipPlan: this.selectedVipPlan, // 选中的VIP计划
          paymentMethod: this.selectedPaymentMethod, // 选中的支付方式
          timestamp: new Date().getTime() // 当前时间戳
        }

        console.log('充值成功接口请求数据:', requestData)

        // 调用接口
        const response = await userApi.memberRechargeSuccess(requestData)

        console.log('充值成功接口响应:', response)

        if (response && response.code === 200) {
          console.log('充值成功接口调用成功')
          // 充值成功提示已在支付状态检查时显示，这里不再重复显示
        } else {
          console.warn('充值成功接口返回异常:', response)
          // 即使接口返回异常，也不影响后续流程
        }
      } catch (error) {
        console.error('调用充值成功接口失败:', error)
        // 即使接口调用失败，也不影响后续流程
        // 不显示警告信息，避免用户困惑
      }
    },

    // 刷新个人信息数据
    async refreshPersonalInfo() {
      try {

        // 调用 /manage/memberinfo/myinfo 接口
        const response = await userApi.getUserInfo()
        console.log('个人信息刷新响应:', response)

        if (response && response.code === 200) {

          // 更新Vuex store中的用户信息
          if (response) {
            // 更新会员信息
            if (response.memberInfo) {
              this.updateMemberInfo(response.memberInfo)
              // 验证Vuex状态是否已更新
              await this.$nextTick()
            }

            // 更新用户基本信息
            if (response.user) {
              if (response.user.avatar || response.user.avator) {
                const avatarUrl = response.user.avatar || response.user.avator
                this.updateUserAvatar(avatarUrl)
              }
              if (response.user.nickName) {
                this.updateUserNickName(response.user.nickName)
              }
              if (response.user.userId || response.user.id) {
                const userId = response.user.userId || response.user.id
                this.updateUserId(userId)
              }
            }
          } else {
            console.warn('响应中没有data字段')
          }

          // 强制更新Vuex状态
          await this.$nextTick()

          console.log('个人信息已更新')
        } else {
          console.warn('个人信息刷新失败:', response)
        }
      } catch (error) {
        console.error('刷新个人信息失败:', error)
        // 不显示警告信息，避免用户困惑
      }
    },

    // 刷新所有数据
    async refreshAllData() {
      try {
        // 1. 重新获取会员充值二维码（如果需要的话）
        // await this.fetchMemberRechargeQRCode()

        // 2. 触发父组件或全局状态更新
        this.$emit('recharge-success')

        // 3. 可以在这里添加其他需要刷新的接口调用
        // 例如：刷新用户信息、会员信息等

        console.log('会员升级所有数据刷新完成')
      } catch (error) {
        console.error('刷新会员升级数据时出错:', error)
      }
    },

    // 选择VIP计划
    async selectVipPlan(planType) {
      // 如果选择的是当前已选中的计划，不需要重新获取
      if (this.selectedVipPlan === planType) {
        return
      }

      // 更新选中的VIP计划
      this.selectedVipPlan = planType

      // 清除之前的错误状态、二维码和停止支付检查
      this.qrCodeError = null
      this.showPaymentServiceUnavailable = false
      this.memberRechargeQRCode = null
      this.currentOrderId = null
      this.stopPaymentStatusCheck()

      // 显示加载状态
      this.qrCodeLoading = true

      // 等待DOM更新后重新获取二维码
      await this.$nextTick()

      // 重新获取二维码
      await this.fetchMemberRechargeQRCode()
    },

    // 选择支付方式
    async selectPaymentMethod(method) {
      // 已选支付宝且再次点击支付宝时无需处理；选微信时每次点击都重新获取支付码（避免从支付宝切回微信时仍用旧码导致失效）
      if (this.selectedPaymentMethod === method && method === 'alipay') {
        return
      }

      // 更新选中的支付方式（v-model 可能已更新，此处保证一致）
      this.selectedPaymentMethod = method

      // 清除之前的错误状态、二维码和停止支付检查
      this.qrCodeError = null
      this.showPaymentServiceUnavailable = false
      this.memberRechargeQRCode = null
      this.currentOrderId = null
      this.stopPaymentStatusCheck()

      // 如果是支付宝支付，不自动调用API，需要用户点击"立即支付"按钮
      if (method === 'alipay') {
        this.qrCodeLoading = false
        return
      }

      // 微信等支付方式：每次选中都重新获取二维码，确保支付码有效
      this.qrCodeLoading = true

      await this.$nextTick()
      await this.fetchMemberRechargeQRCode()
    },

    // 立即支付（支付宝支付专用）
    async handlePayNow() {
      // 只有选择支付宝支付时才可以使用此方法
      if (this.selectedPaymentMethod !== 'alipay') {
        return
      }

      // 调用获取二维码接口
      await this.fetchMemberRechargeQRCode()
    },

    // 处理打开会员升级弹窗事件
    handleOpenMembershipUpgrade() {
      console.log('收到打开会员升级弹窗事件')
      this.openMembershipUpgrade()
    },

    // 打开会员升级弹窗
    openMembershipUpgrade() {
      this.showMembershipUpgrade = true
      // 弹窗打开后，只有非支付宝支付方式才自动获取二维码
      this.$nextTick(() => {
        // 如果当前选择的是微信支付，自动获取二维码
        if (this.selectedPaymentMethod !== 'alipay') {
          this.fetchMemberRechargeQRCode()
        } else {
          // 支付宝支付需要用户点击"立即支付"按钮
          this.qrCodeLoading = false
          this.memberRechargeQRCode = null
        }
      })
    },

    // 打开会员续费弹窗
    openMembershipRenewal() {
      this.showMembershipUpgrade = true
      // 弹窗打开后，只有非支付宝支付方式才自动获取二维码
      this.$nextTick(() => {
        // 如果当前选择的是微信支付，自动获取二维码
        if (this.selectedPaymentMethod !== 'alipay') {
          this.fetchMemberRechargeQRCode()
        } else {
          // 支付宝支付需要用户点击"立即支付"按钮
          this.qrCodeLoading = false
          this.memberRechargeQRCode = null
        }
      })
    },

    showLogin() {
      this.loginVisible = true
    },

    showUserInfo() {
      this.showInfo = true
    },

    goToHomepage() {
      // this.$router.push('/homepage')
      this.userInfo = {
        avator: require('@/assets/images/g_01.jpg'),
        nickName: '东京街角1号',
        userId: 'USRID405031'
      }
    },

    goToMessagePage() {
      try {
        console.log('开始跳转到个人信息页面...')

        // 关闭弹窗
        this.showUserPopup = false
        this.popupKeepOpen = false

        // 跳转到个人信息页面
        this.$router.push('/message').catch(err => {
          console.error('路由跳转失败:', err)
          if (err.name === 'NavigationDuplicated') {
            console.log('路由重复，忽略错误')
          } else {
            // 如果跳转失败，尝试使用replace
            this.$router.replace('/message').catch(replaceErr => {
              console.error('路由replace也失败:', replaceErr)
              // 最后尝试直接跳转到首页
              this.$router.push('/')
            })
          }
        })

        console.log('跳转指令已发送')
      } catch (error) {
        console.error('跳转到个人信息页面异常:', error)
        console.error('错误详情:', {
          message: error.message,
          stack: error.stack
        })

        // 尝试使用window.location作为备选方案
        try {
          window.location.href = '/message'
        } catch (fallbackError) {
          console.error('备选跳转也失败:', fallbackError)
          // 最后尝试跳转到首页
          this.$router.push('/')
        }
      }
    },

    async handleLogin() {
      try {
        console.log('开始登录流程...')
        console.log('登录表单数据:', this.loginForm)

        // 验证手机号
        if (!this.loginForm.phone) {
          await this.$nextTick()
          this.$message({
            message: '请输入手机号',
            type: 'error',
            duration: 3000,
            customClass: 'login-error-message'
          })
          return
        }
        if (!/^1[3-9]\d{9}$/.test(this.loginForm.phone)) {
          await this.$nextTick()
          this.$message({
            message: '请输入正确的手机号',
            type: 'error',
            duration: 3000,
            customClass: 'login-error-message'
          })
          return
        }

        // 验证验证码
        if (!this.loginForm.verificationCode) {
          await this.$nextTick()
          this.$message({
            message: '请输入验证码',
            type: 'error',
            duration: 3000,
            customClass: 'login-error-message'
          })
          return
        }
        if (!/^\d{6}$/.test(this.loginForm.verificationCode)) {
          await this.$nextTick()
          this.$message({
            message: '验证码为6位数字',
            type: 'error',
            duration: 3000,
            customClass: 'login-error-message'
          })
          return
        }

        // 显示加载状态
        const loading = this.$loading({
          lock: true,
          text: '正在登录...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        try {
          // 准备登录数据
          const loginData = {
            phoneNumber: this.loginForm.phone,
            code: this.loginForm.verificationCode,
            operatorType: '4' // 添加固定的operatorType字段
          }


          // 调用登录API
          const loginResponse = await userApi.login(loginData)
          // 由于API响应拦截器已经处理了错误，这里只需要处理成功情况
          // 存储token到本地 - 检查不同的可能的token字段名
          let token = null
          if (loginResponse.token) {
            token = loginResponse.token
          } else if (loginResponse.data && loginResponse.data.token) {
            token = loginResponse.data.token
          } else if (loginResponse.accessToken) {
            token = loginResponse.accessToken
          }

          if (token) {
            tokenUtils.setToken(token)
            console.log('Token已存储到本地:', token)
            // 获取用户信息
            try {
              const userInfoResponse = await userApi.getUserInfo()
              console.log('用户信息:', userInfoResponse)

              // 检查并设置默认头像
              if (userInfoResponse && userInfoResponse.user) {
                // 检查用户是否有头像，如果没有则设置默认头像
                if (!userInfoResponse.user.avatar && !userInfoResponse.user.avator) {
                  userInfoResponse.user.avatar = require('@/assets/images/M-0510user.png')
                  console.log('为用户设置默认头像:', userInfoResponse.user.avatar)
                }
              }

              // 将用户信息存储到本地
              if (userInfoResponse) {
                tokenUtils.setUserInfo(userInfoResponse)
                console.log('用户信息已存储到本地')

                // 更新组件状态中的用户信息
                this.userInfo = userInfoResponse

                // 立即同步更新 Vuex store，确保用户信息显示正确
                this.syncUserInfoToStore(userInfoResponse)
              }
            } catch (userInfoError) {
              console.error('获取用户信息异常:', userInfoError)
              successMessage = '登录成功，但获取用户信息失败'
            }
          } else {
            console.error('登录响应中没有找到token字段')
            // 关闭登录弹窗
            this.closeLoginModal()

            // 等待弹窗完全关闭后显示错误消息
            await this.$nextTick()

            // 显示错误消息
            this.$message({
              message: '登录响应格式错误，请联系管理员',
              type: 'error',
              duration: 3000,
              customClass: 'login-error-message'
            })
            return
          }
          // 关闭登录弹窗
          this.closeLoginModal()
          // 等待弹窗完全关闭后显示成功消息
          await this.$nextTick()

          // 跳转到首页（如果当前不在首页）
          if (this.$route.path !== '/') {
            this.$router.push('/').catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                console.error('路由跳转失败:', err)
              }
            })
          } else {
            // 如果已经在首页，刷新页面以显示登录状态
            window.location.reload()
          }
        } finally {
          loading.close()
        }
      } catch (error) {
        console.error('登录失败:', error)
        // 关闭登录弹窗
        // this.closeLoginModal()
        // 等待弹窗完全关闭后显示错误消息
        await this.$nextTick()
        // 显示登录失败消息（提高优先级，确保可见）
        // this.$message({
        //   message: error.message,
        //   type: 'error',
        //   duration: 3000,
        //   customClass: 'login-error-message'
        // })
      }
    },

    handleCommand(command) {
      if (command === 'logout') {
        this.handleLogout()
      } else if (command === 'profile') {
        this.$message.info('个人中心功能开发中...')
      }
    },

    goToUserHomepage() {
      try {
        // 添加点击波纹效果
        const homepageModule = document.querySelector('.homepage-module')
        if (homepageModule) {
          homepageModule.classList.add('clicked')
          setTimeout(() => {
            homepageModule.classList.remove('clicked')
          }, 600)
        }

        // 关闭用户弹窗
        if (this.showUserPopup !== undefined) {
          this.showUserPopup = false
        }
        if (this.popupKeepOpen !== undefined) {
          this.popupKeepOpen = false
        }

        // 直接跳转到homepage页面，并定位到"我的素材"下的"我的声音"
        this.$router.push({
          path: '/homepage',
          query: { materialTab: '4' }
        }).catch(err => {
          console.error('路由跳转失败:', err)
          // 如果路由跳转失败，使用window.location
          window.location.href = '/homepage?materialTab=4'
        })
      } catch (error) {
        console.error('进入主页失败:', error)
        // 最后的备选方案
        window.location.href = '/homepage?materialTab=4'
      }
    },

    getHomepageTooltip() {
      return ''
      if (!this.userInfo) {
        return '请先登录以访问个人主页'
      }
      if (!this.userInfo.userId || !this.userInfo.nickName) {
        return '用户信息不完整，请重新登录'
      }
      return `欢迎回来，${this.userInfo.nickName}！`
    },

    getUserStatus() {
      if (!this.userInfo) {
        return { type: 'offline', text: '离线' }
      }

      // 这里可以根据实际业务逻辑判断用户状态
      // 比如检查最后活跃时间、在线状态等
      const now = new Date()
      const lastActive = new Date(this.userInfo.lastActive || now)
      const timeDiff = now - lastActive

      if (timeDiff < 5 * 60 * 1000) { // 5分钟内活跃
        return { type: 'online', text: '在线' }
      } else if (timeDiff < 30 * 60 * 1000) { // 30分钟内活跃
        return { type: 'busy', text: '忙碌' }
      } else {
        return { type: 'offline', text: '离线' }
      }
    },

    recordHomepageVisit() {
      if (!this.userInfo) return

      const visitRecord = {
        userId: this.userInfo.userId,
        nickName: this.userInfo.nickName,
        visitTime: new Date().toISOString(),
        timestamp: Date.now()
      }

      // 添加到访问历史
      this.homepageVisitHistory.unshift(visitRecord)

      // 限制历史记录数量，最多保存10条
      if (this.homepageVisitHistory.length > 10) {
        this.homepageVisitHistory = this.homepageVisitHistory.slice(0, 10)
      }

      // 保存到localStorage
      localStorage.setItem('homepageVisitHistory', JSON.stringify(this.homepageVisitHistory))

      // 更新用户最后活跃时间
      if (this.userInfo) {
        this.userInfo.lastActive = new Date().toISOString()
      }

      console.log('访问记录已保存:', visitRecord)
    },

    loadHomepageVisitHistory() {
      const history = localStorage.getItem('homepageVisitHistory')
      if (history) {
        try {
          this.homepageVisitHistory = JSON.parse(history)
          // 将访问时间转换为Date对象
          this.homepageVisitHistory.forEach(record => {
            record.visitTime = new Date(record.visitTime)
          })
        } catch (e) {
          this.homepageVisitHistory = []
        }
      } else {
        this.homepageVisitHistory = []
      }
    },

    formatLastVisitTime(visitTime) {
      if (!visitTime) return '从未访问'
      const now = new Date()
      const lastVisit = new Date(visitTime)
      const timeDiff = now - lastVisit

      if (timeDiff < 60 * 1000) { // 小于1分钟
        return '刚刚访问'
      } else if (timeDiff < 60 * 60 * 1000) { // 小于1小时
        return `${Math.floor(timeDiff / (60 * 1000))}分钟前`
      } else if (timeDiff < 24 * 60 * 60 * 1000) { // 小于1天
        return `${Math.floor(timeDiff / (60 * 60 * 1000))}小时前`
      } else {
        return `${Math.floor(timeDiff / (24 * 60 * 60 * 1000))}天前`
      }
    },

    // 格式化可用次数显示（与homepage.vue保持一致）
    formatAvailableCount(availabeCount) {
      if (availabeCount === null || availabeCount === undefined) {
        return '0次'
      }
      // 处理数字-1和字符串"-1"两种情况
      if (availabeCount === -1 || availabeCount === '-1' || String(availabeCount) === '-1') {
        return '∞次'
      }
      return availabeCount + '次'
    },

    // 格式化可用时长显示（与homepage.vue保持一致）
    formatAvailableTime(availabeTime) {
      if (availabeTime === null || availabeTime === undefined) {
        return '0分钟'
      }
      // 处理数字-1和字符串"-1"两种情况
      if (availabeTime === -1 || availabeTime === '-1' || String(availabeTime) === '-1') {
        return '∞分钟'
      }
      return availabeTime + '分钟'
    },

    handleAvatarMouseEnter() {
      // 立即显示弹窗
      this.showUserPopup = true
      this.popupKeepOpen = false // 重置保持打开状态
    },

    handleAvatarMouseLeave(event) {
      // 鼠标离开头像时，延迟关闭弹窗，给用户时间移动到弹窗上
      setTimeout(() => {
        // 如果弹窗需要保持打开，则不关闭
        if (this.popupKeepOpen) {
          return
        }

        // 检查鼠标是否真的离开了整个头像区域
        const avatarContainer = event.currentTarget
        const popup = document.querySelector('.user-popup')

        if (avatarContainer && popup) {
          const rect = avatarContainer.getBoundingClientRect()
          const mouseX = event.clientX
          const mouseY = event.clientY

          // 如果鼠标不在头像区域内，则关闭弹窗
          if (mouseX < rect.left || mouseX > rect.right || mouseY < rect.top || mouseY > rect.bottom) {
            this.showUserPopup = false
          }
        }
      }, 150) // 延迟150ms关闭
    },

    handlePopupMouseEnter() {
      // 鼠标进入弹窗时，保持弹窗打开
      this.showUserPopup = true
      this.popupKeepOpen = true // 设置保持打开状态
    },

    handlePopupMouseLeave(event) {
      // 鼠标离开弹窗时，延迟关闭弹窗
      setTimeout(() => {
        // 如果弹窗需要保持打开，则不关闭
        if (this.popupKeepOpen) {
          return
        }

        // 检查鼠标是否真的离开了弹窗区域
        const popup = event.currentTarget
        if (popup) {
          const rect = popup.getBoundingClientRect()
          const mouseX = event.clientX
          const mouseY = event.clientY

          // 如果鼠标不在弹窗区域内，则关闭弹窗
          if (mouseX < rect.left || mouseX > rect.right || mouseY < rect.top || mouseY > rect.bottom) {
            this.showUserPopup = false
          }
        }
      }, 200) // 延迟200ms关闭，给用户更多时间
    },

    async handleLogout() {
      // 首先关闭所有弹窗，防止显示不完整的信息
      this.showUserPopup = false
      this.popupKeepOpen = false
      this.loginVisible = false  // 关闭登录/注册弹框
      this.registerVisible = false  // 关闭注册弹框
      this.showMembershipUpgrade = false  // 关闭会员升级弹框
      this.showCustomerServicePopup = false  // 关闭客服弹框

      // 清除访问历史记录
      this.homepageVisitHistory = []

      // 清除localStorage中的用户相关数据
      localStorage.removeItem('homepageVisitHistory')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('token')

      // 清除token和用户信息
      tokenUtils.clearAuth()

      // 同步清空 Vuex 中的用户状态，确保 isLoggedIn 立即变为 false
      if (this.$store && this.$store.dispatch) {
        try {
          await this.$store.dispatch('user/logout')
        } catch (e) {
          // 兜底直接提交清理
          this.$store.commit('user/CLEAR_USER_DATA')
        }
      }

      // 清除本地用户信息，回到默认状态（在Vuex清理之后）
      this.userInfo = null

      // 等待弹窗完全关闭和状态更新
      await this.$nextTick()

      // 强制触发视图更新，确保所有依赖 userInfo 的组件都能正确响应
      this.$forceUpdate()

      // 使用setTimeout确保DOM完全更新
      // setTimeout(() => {
      //   // 显示退出成功消息（提高优先级，确保可见）
      //   this.$message({
      //     message: '已退出登录',
      //     type: 'success',
      //     duration: 3000,
      //     customClass: 'logout-success-message'
      //   })
      // }, 100)

      // 跳转到首页（如果当前不在首页）
      if (this.$route.path !== '/') {
        this.$router.push('/').catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('路由跳转失败:', err)
          }
        })
      } else {
        window.location.reload()
      }
      // 移除页面刷新，Vue的响应式系统会自动更新UI状态
    },

    // 添加弹窗显示状态管理方法
    togglePopup() {
      this.showUserPopup = !this.showUserPopup
      this.popupKeepOpen = this.showUserPopup
    },

    // 强制关闭弹窗
    forceClosePopup() {
      this.showUserPopup = false
      this.popupKeepOpen = false
    },

    handleGlobalClick(event) {
      // 检查点击是否在全部产品模块内部
      const allProductsModule = event.target.closest('.all-products-module')
      if (allProductsModule) {
        return
      }

      // 点击其他区域时关闭全部产品弹窗
      this.showAllProductsPopup = false

      // 检查点击是否在用户弹窗内部
      const userPopup = document.querySelector('.user-popup')
      if (userPopup && userPopup.contains(event.target)) {
        return
      }

      // 检查点击是否在头像区域内部
      const avatarContainer = event.target.closest('.user-info > div:last-child')
      if (avatarContainer && avatarContainer.contains(event.target)) {
        return
      }

      // 如果点击不在任何弹窗或头像区域，则关闭弹窗
      this.forceClosePopup()
    },

    // 处理显示客服弹窗的window事件
    handleShowCustomerServiceEvent() {
      this.showCustomerService()
    },

    // 显示客服弹窗
    showCustomerService() {
      this.showCustomerServicePopup = true
    },

    // 关闭客服弹窗
    closeCustomerService() {
      this.showCustomerServicePopup = false
    },

    openConsultModal() {
      this.showConsultModal = true
    },

    closeConsultModal() {
      this.showConsultModal = false
    },

    resetConsultForm() {
      this.consultForm = {
        nickname: '',
        phone: '',
        email: '',
        interest: '',
        city: '',
        remark: ''
      }
    },

    /**
     * 留言咨询提交：请求体与短剧端 App.vue createLeadInquiry 一致。
     */
    async submitConsultForm() {
      const f = this.consultForm
      const phone = String(f.phone || '').trim()
      const email = String(f.email || '').trim()
      if (!phone) {
        this.$message.warning('请填写手机号码')
        return
      }
      if (!/^1\d{10}$/.test(phone)) {
        this.$message.warning('请输入正确的11位手机号码')
        return
      }
      if (!f.interest) {
        this.$message.warning('请选择您想了解的内容')
        return
      }
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.$message.warning('请输入正确的邮箱地址')
        return
      }
      const city = String(f.city || '').trim() || '上海'
      const payload = {
        phone,
        interest: String(f.interest || '').trim(),
        city
      }
      const salutation = String(f.nickname || '').trim()
      if (salutation) payload.salutation = salutation
      if (email) payload.email = email
      const remark = String(f.remark || '').trim()
      if (remark) payload.remark = remark

      this.consultSubmitting = true
      try {
        await createLeadInquiry(payload)
        this.$message.success('提交成功，我们会尽快与您联系')
        this.closeConsultModal()
        this.resetConsultForm()
      } catch (e) {
        // 业务码非 200、HTTP 错误等已由 @/utils/request 拦截器统一 Message，此处避免重复弹窗
      } finally {
        this.consultSubmitting = false
      }
    },

    // 关闭支付跳转弹窗
    closePaymentRedirectDialog() {
      this.showPaymentRedirectDialog = false
      this.pageRedirectionData = null
    },

    // 复制微信号
    copyWechatId() {
      const wechatId = 'digital_factory'
      if (navigator.clipboard) {
        navigator.clipboard.writeText(wechatId).then(() => {
          this.$message.success('微信号已复制到剪贴板')
        }).catch(() => {
          this.fallbackCopyTextToClipboard(wechatId)
        })
      } else {
        this.fallbackCopyTextToClipboard(wechatId)
      }
    },

    // 兼容性复制方法
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.position = 'fixed'
      textArea.style.opacity = '0'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        document.execCommand('copy')
        this.$message.success('微信号已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败，请手动复制')
      }
      document.body.removeChild(textArea)
    },

    // 获取验证码
    async getVerificationCode() {
      if (!this.loginForm.phone) {
        this.$message.error('请先输入手机号')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.loginForm.phone)) {
        this.$message.error('请输入正确的手机号')
        return
      }

      try {
        // 调用API获取短信验证码
        await userApi.getSmsCode(this.loginForm.phone)

        // 开始倒计时
        this.countdown = 60
        const timer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            clearInterval(timer)
          }
        }, 1000)

        this.$message.success('验证码已发送，请查收短信')
      } catch (error) {
        console.error('获取验证码失败:', error)
        this.$message.error(error.message || '获取验证码失败，请稍后重试')
      }
    },

    // 关闭登录弹窗
    closeLoginModal() {
      this.loginVisible = false
      this.loginForm.phone = ''
      this.loginForm.verificationCode = ''
      this.countdown = 0
    },

    // 跳转到注册页面
    goToRegister() {
      this.loginVisible = false
      this.registerVisible = true
    },

    // 跳转到登录页面
    goToLogin() {
      this.registerVisible = false
      this.loginVisible = true
    },

    // 处理注册
    handleRegister() {
      this.loginVisible = false
      this.registerVisible = true
    },

    // 处理注册提交
    async handleRegisterSubmit() {
      try {
        // 验证手机号
        if (!this.registerForm.phone) {
          await this.$nextTick()
          setTimeout(() => {
            this.$message({
              message: '请输入手机号',
              type: 'error',
              duration: 3000,
              customClass: 'login-error-message'
            })
          }, 100)
          return
        }
        if (!/^1[3-9]\d{9}$/.test(this.registerForm.phone)) {
          await this.$nextTick()
          setTimeout(() => {
            this.$message({
              message: '请输入正确的手机号',
              type: 'error',
              duration: 3000,
              customClass: 'login-error-message'
            })
          }, 100)
          return
        }

        // 验证验证码
        if (!this.registerForm.verificationCode) {
          await this.$nextTick()
          setTimeout(() => {
            this.$message({
              message: '请输入验证码',
              type: 'error',
              duration: 3000,
              customClass: 'login-error-message'
            })
          }, 100)
          return
        }
        if (!/^\d{6}$/.test(this.registerForm.verificationCode)) {
          await this.$nextTick()
          setTimeout(() => {
            this.$message({
              message: '验证码为6位数字',
              type: 'error',
              duration: 3000,
              customClass: 'login-error-message'
            })
          }, 100)
          return
        }

        // 验证用户协议
        if (!this.registerForm.agreement) {
          await this.$nextTick()
          setTimeout(() => {
            this.$message({
              message: '请阅读并同意用户协议',
              type: 'error',
              duration: 3000,
              customClass: 'login-error-message'
            })
          }, 100)
          return
        }

        // 显示加载状态
        const loading = this.$loading({
          lock: true,
          text: '正在注册...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 准备注册数据
        const registerData = {
          inviteCode: this.registerForm.invitationCode || '',
          code: this.registerForm.verificationCode,
          operatorType: '4',
          phoneNumber: this.registerForm.phone
        }


        // 优先尝试注册并获取token的API
        let response = {}
        try {
          response = await userApi.register(registerData)
        } catch (error) {
        }
        console.log('普通注册:', response)
        loading.close()

        if (response.code === 200) {

          setTimeout(() => {
            // 显示注册成功消息（提高优先级，确保可见）
            this.$message({
              message: '注册成功！请登录',
              type: 'success',
              duration: 3000,
              customClass: 'register-success-message'
            })
          }, 100)
          this.goToLogin()

          return

          // 检查响应中是否有token
          let token = null
          if (response.token) {
            token = response.token
          } else if (response.data && response.data.token) {
            token = response.data.token
          } else if (response.accessToken) {
            token = response.accessToken
          }

          if (token) {
            // 保存token到本地存储
            tokenUtils.setToken(token)
            console.log('注册成功，token已保存:', token)

            // 更新Vuex状态
            this.$store.commit('user/SET_TOKEN', token)
            this.isLoggedIn = true
          } else {
            console.warn('注册成功但未返回token，将在自动登录中获取')
          }
          // 关闭注册弹窗
          this.closeRegisterModal()

          // 等待弹窗完全关闭后显示注册成功消息
          await this.$nextTick()

          // 再次确保注册弹窗已关闭
          this.registerVisible = false

          // 使用setTimeout确保DOM完全更新
          setTimeout(() => {
            // 显示注册成功消息（提高优先级，确保可见）
            this.$message({
              message: '注册成功！请登录',
              type: 'success',
              duration: 3000,
              customClass: 'register-success-message'
            })
          }, 100)

          // 如果注册时没有获取到token，则自动登录获取token
          if (!token) {
            console.log('注册时未获取到token，开始自动登录...')
            let originalMessageError = null
            try {
              const loginData = {
                phoneNumber: this.registerForm.phone,
                code: this.registerForm.verificationCode,
                operatorType: '4' // 确保自动登录时也发送operatorType
              }

              // 在自动登录前临时禁用底层的错误提示
              originalMessageError = this.$message.error
              this.$message.error = () => {
              } // 临时禁用错误消息

              const loginResponse = await userApi.login(loginData)

              // 恢复底层的错误提示
              this.$message.error = originalMessageError

              if (loginResponse.code === 200) {
                // 登录成功的消息会在登录逻辑中处理，这里不需要重复显示

                // 存储token到本地
                if (loginResponse && loginResponse.token) {
                  tokenUtils.setToken(loginResponse.token)
                  console.log('Token已存储到本地')

                  // 获取用户信息
                  try {
                    const userInfoResponse = await userApi.getUserInfo()
                    if (userInfoResponse.code === 200) {
                      console.log('用户信息:', userInfoResponse)

                      // 为新注册用户设置默认头像
                      if (userInfoResponse && userInfoResponse.user) {
                        // 检查用户是否有头像，如果没有则设置默认头像
                        if (!userInfoResponse.user.avatar && !userInfoResponse.user.avator) {
                          userInfoResponse.user.avatar = require('@/assets/images/M-0510user.png')
                          console.log('为新注册用户设置默认头像:', userInfoResponse.user.avatar)
                        }
                      }

                      // 将用户信息存储到本地
                      if (userInfoResponse) {
                        tokenUtils.setUserInfo(userInfoResponse)
                        console.log('用户信息已存储到本地')
                      }
                    } else {
                      console.error('获取用户信息失败:', userInfoResponse.msg)
                    }
                  } catch (userInfoError) {
                    console.error('获取用户信息异常:', userInfoError)
                  }

                  // 关闭注册弹窗
                  this.closeRegisterModal()
                  // 跳转到home页面并刷新
                  if (this.$route.path !== '/') {
                    this.$router.push('/').then(() => {
                      window.location.reload()
                    })
                  } else {
                    // 如果已经在首页，直接刷新
                    window.location.reload()
                  }
                }
              } else {
                // 关闭注册弹窗
                this.closeRegisterModal()
                // 跳转到登录页面
                this.showLogin()
              }
            } catch (loginError) {
              console.error('自动登录失败:', loginError)

              // 恢复底层的错误提示（以防万一）
              if (typeof originalMessageError === 'function') {
                this.$message.error = originalMessageError
              }

              // 关闭注册弹窗
              this.closeRegisterModal()

              // 等待弹窗完全关闭后显示错误消息
              await this.$nextTick()

              // 再次确保注册弹窗已关闭
              this.registerVisible = false

              // 使用setTimeout确保DOM完全更新
              setTimeout(() => {
                // 显示自动登录失败的消息
                let errorMessage = '自动登录失败，请手动登录'
                if (loginError.message && loginError.message.includes('用户不存在')) {
                  errorMessage = '注册成功，但自动登录失败，请稍后手动登录'
                } else if (loginError.message && loginError.message.includes('密码错误')) {
                  errorMessage = '注册成功，但自动登录失败，请稍后手动登录'
                } else if (loginError.message && loginError.message.includes('验证码')) {
                  errorMessage = '注册成功，但验证码已过期，请重新登录'
                }

                this.$message({
                  message: errorMessage,
                  type: 'warning',
                  duration: 5000,
                  customClass: 'login-error-message'
                })
              }, 100)

              // 跳转到登录页面
              this.showLogin()
            }
          } // 结束自动登录的if块
        }
      } catch (error) {
        console.error('注册失败:', error)
      }
    },

    // 获取注册验证码
    async getRegisterVerificationCode() {
      if (!this.registerForm.phone) {
        // this.closeRegisterModal()
        await this.$nextTick()
        this.registerVisible = false
        setTimeout(() => {
          this.$message({
            message: '请先输入手机号',
            type: 'error',
            duration: 3000,
            customClass: 'login-error-message'
          })
        }, 100)
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.registerForm.phone)) {
        // this.closeRegisterModal()
        await this.$nextTick()
        this.registerVisible = false
        setTimeout(() => {
          this.$message({
            message: '请输入正确的手机号',
            type: 'error',
            duration: 3000,
            customClass: 'login-error-message'
          })
        }, 100)
        return
      }

      try {
        // 调用API获取短信验证码
        await userApi.getSmsCode(this.registerForm.phone)

        // 开始倒计时
        this.registerCountdown = 60
        const timer = setInterval(() => {
          this.registerCountdown--
          if (this.registerCountdown <= 0) {
            clearInterval(timer)
          }
        }, 1000)

        this.$message.success('验证码已发送，请查收短信')
      } catch (error) {
        console.error('获取验证码失败:', error)
        this.$message.error(error.message || '获取验证码失败，请稍后重试')
      }
    },

    // 关闭注册弹窗
    closeRegisterModal() {
      this.registerVisible = false
      this.registerForm.phone = ''
      this.registerForm.verificationCode = ''
      this.registerForm.invitationCode = ''
      this.registerForm.agreement = false
      this.registerCountdown = 0
    },

    // Token验证和恢复函数
    async validateAndRecoverToken() {
      // console.log('开始验证和恢复token...')

      // 1. 检查localStorage中的token
      let token = localStorage.getItem('token')
      if (token) {
        // console.log('✓ 找到localStorage token')
        return true
      }

      // 2. 检查tokenUtils中的token
      const tokenUtilsToken = tokenUtils.getToken()
      if (tokenUtilsToken) {
        // console.log('✓ 找到tokenUtils token，正在恢复到localStorage')
        localStorage.setItem('token', tokenUtilsToken)
        token = tokenUtilsToken
      }

      // 3. 检查Vuex中的token
      const vuexToken = this.$store ? this.$store.state.user.token : null
      if (vuexToken && !token) {
        // console.log('✓ 找到Vuex token，正在恢复到localStorage')
        localStorage.setItem('token', vuexToken)
        token = vuexToken
      }

      // 4. 检查是否有用户信息，如果有则尝试从用户信息中恢复token
      const userInfo = tokenUtils.getUserInfo()
      if (userInfo && userInfo.token && !token) {
        // console.log('✓ 从用户信息中找到token，正在恢复')
        localStorage.setItem('token', userInfo.token)
        token = userInfo.token
      }

      if (token) {
        // console.log('✅ Token恢复成功')
        return true
      }

      // console.log('❌ 无法恢复token，用户需要重新登录')
      return false
    },



    // 全局调试函数 - 在控制台中可调用
    setupGlobalDebug() {
      if (typeof window !== 'undefined') {

        window.clearToken = () => {
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')

        }
        window.recoverToken = () => {
          // 简单的token恢复逻辑
          const token = tokenUtils.getToken() || localStorage.getItem('token')
          if (token) {
            localStorage.setItem('token', token)

          } else {

          }
        }

      }
    },

    // 同步用户信息到 Vuex store
    syncUserInfoToStore(userInfoData) {
      if (!userInfoData) return

      try {
        // 更新用户头像
        if (userInfoData.user) {
          const avatar = userInfoData.user.avatar || userInfoData.user.avator
          if (avatar) {
            this.updateUserAvatar(avatar)
          }

          // 更新用户昵称
          if (userInfoData.user.nickName) {
            this.updateUserNickName(userInfoData.user.nickName)
          }

          // 更新用户ID
          if (userInfoData.user.userId || userInfoData.user.id) {
            const userId = userInfoData.user.userId || userInfoData.user.id
            this.updateUserId(userId)
          }
        }

        // 更新会员信息
        if (userInfoData.memberInfo) {
          this.updateMemberInfo(userInfoData.memberInfo)
        }
      } catch (error) {
        console.error('同步用户信息到 Vuex store 失败:', error)
      }
    },

    // 检查本地存储的用户信息
    async checkLocalUserInfo() {
      // 检查是否有token
      const token = tokenUtils.getToken()
      if (token) {

        // 检查是否有本地存储的用户信息
        const localUserInfo = tokenUtils.getUserInfo()
        if (localUserInfo) {
          // 检查本地用户信息是否有头像，如果没有则设置默认头像
          if (localUserInfo.user && (!localUserInfo.user.avatar && !localUserInfo.user.avator)) {
            localUserInfo.user.avatar = require('@/assets/images/M-0510user.png')
            console.log('为本地用户设置默认头像:', localUserInfo.user.avatar)
          }
          this.userInfo = localUserInfo
          // 同步更新 Vuex store
          this.syncUserInfoToStore(localUserInfo)
        } else {
          // 如果没有本地用户信息，但有token，尝试从服务器获取
          try {
            const userInfoResponse = await userApi.getUserInfo()
            if (userInfoResponse.code === 200) {
              // 检查服务器返回的用户信息是否有头像，如果没有则设置默认头像
              if (userInfoResponse.user && (!userInfoResponse.user.avatar && !userInfoResponse.user.avator)) {
                userInfoResponse.user.avatar = require('@/assets/images/M-0510user.png')
                console.log('为服务器用户设置默认头像:', userInfoResponse.user.avatar)
              }
              tokenUtils.setUserInfo(userInfoResponse)
              this.userInfo = userInfoResponse
              // 同步更新 Vuex store
              this.syncUserInfoToStore(userInfoResponse)
            } else {
              tokenUtils.clearAuth()
              this.userInfo = null
            }
          } catch (error) {
            tokenUtils.clearAuth()
            this.userInfo = null
          }
        }
      } else {
        // console.log('未检测到本地token')
        // 清除可能存在的过期用户信息
        tokenUtils.removeUserInfo()
        this.userInfo = null
      }
    },

    // 打开关于我们页面
    openAboutUs(event) {
      event.preventDefault()
      event.stopPropagation()
      window.open('https://futoit.com', '_blank')
    },

    // 处理AI企业营销悬停弹窗鼠标进入
    handleMarketingMouseEnter() {
      // 显示弹窗
      this.showMarketingPopup = true
      // 清除关闭定时器（如果存在）
      if (this.marketingPopupTimer) {
        clearTimeout(this.marketingPopupTimer)
        this.marketingPopupTimer = null
      }
    },

    // 处理AI企业营销悬停弹窗鼠标离开
    handleMarketingMouseLeave() {
      // 延迟关闭，给鼠标移动到弹窗的时间
      this.marketingPopupTimer = setTimeout(() => {
        this.showMarketingPopup = false
      }, 200)
    },

    // 处理弹窗鼠标进入
    handleMarketingPopupEnter() {
      // 清除关闭定时器
      if (this.marketingPopupTimer) {
        clearTimeout(this.marketingPopupTimer)
        this.marketingPopupTimer = null
      }
    },

    // 处理弹窗鼠标离开
    handleMarketingPopupLeave() {
      this.showMarketingPopup = false
    },

    // 关闭AI企业营销弹窗
    closeMarketingPopup() {
      this.showMarketingPopup = false
    },

    // 跳转到弹幕推广页面
    goToBulletScreen() {
      this.showMarketingPopup = false

      // 检查登录状态
      const token = localStorage.getItem('token') || tokenUtils.getToken()
      if (!token || !this.userInfo) {
        // this.$message.warning('请先登录')
        this.showLogin()
        return
      }

      this.$router.push('/bulletScreenpromotion').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转失败:', err)
        }
      })
    },

    // 跳转到邮件推送页面
    goToEmailPushing() {
      this.showMarketingPopup = false

      // 检查登录状态
      const token = localStorage.getItem('token') || tokenUtils.getToken()
      if (!token || !this.userInfo) {
        // this.$message.warning('请先登录')
        this.showLogin()
        return
      }

      this.$router.push('/email/emailPushing').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转失败:', err)
        }
      })
    },

    // 跳转到AI企业营销页面
    goToAIEnterpriseMarketing() {
      this.showMarketingPopup = false
      this.$router.push('/aiEnterpriseMarketing').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转失败:', err)
        }
      })
    },

    // 点击下拉箭头切换全部产品弹窗
    toggleAllProducts() {
      this.showAllProductsPopup = !this.showAllProductsPopup
    },

    // 跳转到产品页面
    goToProductPage(item, event) {
      this.showAllProductsPopup = false
      // 外链交给浏览器按 target="_blank" 打开，中键/右键复制链接也能正常工作
      if (item.external) return
      if (event) event.preventDefault()
      this.$router.push(item.link).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转失败:', err)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  height: 100vh;

  // 当AI企业营销弹窗显示时，主体内容和页脚虚化（已取消）
  // .main-content.blur-background,
  // .footer.blur-background {
  //   filter: blur(4px);
  //   transition: filter 0.3s ease;
  //   pointer-events: none; // 防止在模糊时点击
  // }

  // 确保导航栏不受影响
  .header {
    position: relative;
    z-index: 1001; // 高于弹窗的z-index，确保导航栏清晰
  }
}

/* 用户协议弹窗样式 */
.agreement-dialog {
  .el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
  }
}

.agreement-content {
  line-height: 1.6;
  color: #333;

  .agreement-section {
    margin-bottom: 24px;

    h3 {
      color: #2c3e50;
      font-size: 16px;
      font-weight: 600;
      margin: 0 0 12px 0;
      padding-bottom: 8px;
      border-bottom: 2px solid #e8f4fd;
    }

    p {
      margin: 8px 0;
      font-size: 14px;
      text-align: justify;
      text-indent: 2em;
    }

    ul {
      margin: 8px 0;
      padding-left: 20px;

      li {
        margin: 4px 0;
        font-size: 14px;
        line-height: 1.5;
      }
    }
  }
}

/* 用户协议链接样式 */
.agreement-link {
  color: #409eff;
  cursor: pointer;

  &:hover {
    color: #66b1ff;
  }
}

.header {
  background-color: #010306;
  color: white;
  padding: 0;
  height: 66px !important;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;

  .header-container {
    width: 1180px;
    min-height: 66px;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
  }

  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 66px;
    padding: 0;
    background-color: #010306;
    overflow: visible;
    width: 100%;

    .logo {
      height: 46px;
      width: 62px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .phone {
      height: 16.88px !important;
      width: 12.5px !important;
      margin-left: 100px;

      img {
        width: 100%;
        height: 100%;

      }
    }

    .about-us-link {
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      padding: 0 20px;
      height: 66px;
      line-height: 66px;
      cursor: pointer;
      transition: color 0.3s;
      margin-left: 10px;

      &:hover {
        color: #316CF4;
      }
    }

    //  background-color: aqua;

    .kefu {
      height: 16px;
      width: 16px;

      img {
        width: 100%;
        height: 100%;

      }

      //  background-color: aqua;

    }

    .user-info {
      display: flex;
      align-items: center;
      margin-left: auto;
      flex-shrink: 0;

      .header-nav-action {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-width: 36px;
        min-height: 44px;
        font-weight: 500;
        font-size: 12px;
        color: #c1c1c2;
        cursor: pointer;
        box-sizing: border-box;

        label {
          margin-top: 4px;
          cursor: pointer;
        }
      }

      .header-nav-action__img {
        width: 18px;
        height: 18px;
        object-fit: contain;
        flex-shrink: 0;
      }

      .header-nav-action__img--consult {
        width: 60px;
        height: 50px;
        object-fit: contain;
      }

      .header-user-block {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        cursor: pointer;
        position: relative;
        min-width: 120px;
        flex-shrink: 0;
        box-sizing: border-box;
      }

      .loginViewStyle {
        width: 89px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 2px 2px 2px 2px;
        background: #484952;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 15px;
        color: #FFFFFF;
        text-align: left;
        font-style: normal;
        text-transform: none;

      }

      .el-dropdown-link {
        color: white;
        cursor: pointer;
      }

      // 全部产品模块（尺寸/间距/排版参考 zudaren-web）
      .all-products-module {
        position: relative;
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 8px 0;
        margin-left: 12px;
        margin-right: 12px;
        background: transparent;
        cursor: default;
        flex-shrink: 0;
        box-sizing: border-box;

        .all-products-module__icon {
          width: 18px;
          height: 18px;
          object-fit: contain;
          display: block;
          flex-shrink: 0;
        }

        .all-products-module__text {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: #FFFFFF;
          white-space: nowrap;
        }

        .all-products-module__arrow {
          width: 10px;
          height: 10px;
          padding: 5px;
          margin: -5px;
          box-sizing: content-box;
          object-fit: contain;
          display: block;
          flex-shrink: 0;
          cursor: pointer;
          transition: none;
        }

        // 全部产品下拉弹窗
        .all-products-popup {
          position: fixed;
          top: 66px;
          right: 25px;
          width: 575px;
          max-width: calc(100vw - 32px);
          padding: 25px 40px;
          border-radius: 11px;
          background: #232222;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.45);
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 23px 40px;
          z-index: 10005;
          box-sizing: border-box;
        }

        .all-products-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 0;
          border-radius: 8px;
          cursor: pointer;
          text-decoration: none;
          color: inherit;
        }

        .all-products-item-info {
          display: flex;
          flex-direction: column;
          gap: 10px;
          flex: 1;
          min-width: 0;
        }

        .all-products-item-head {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .all-products-item-title {
          font-family: PingFang SC, PingFang SC;
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          color: #FFFFFF;
          white-space: nowrap;
        }

        .all-products-item-badge {
          padding: 2px 8px;
          border-radius: 6px;
          background: #FFA657;
          color: #FFFFFF;
          font-family: PingFang SC, PingFang SC;
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          white-space: nowrap;
        }

        .all-products-item-desc {
          margin: 0;
          font-family: PingFang SC, PingFang SC;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: #A2A2A2;
          white-space: nowrap;
        }

        .all-products-item-arrow {
          display: block;
          width: 10px;
          height: 10px;
          flex-shrink: 0;
          align-self: flex-start;
          margin-top: 6px;
          margin-right: 16px;
          object-fit: contain;
        }

        // 弹窗淡入位移动画（与 zudaren-web 一致）
        .products-pop-enter-active,
        .products-pop-leave-active {
          transition: opacity 0.15s ease, transform 0.15s ease;
        }

        .products-pop-enter,
        .products-pop-leave-to {
          opacity: 0;
          transform: translateY(-4px);
        }
      }
    }
  }
}

// 添加 el-menu 样式
.el-menu {
  border: none !important;
  height: 66px !important;
  line-height: 66px !important;
  max-height: 66px !important;
  overflow: visible;
  display: flex !important; // 确保使用flex布局以支持order属性
  align-items: center;

  // 首页 - order: 1 (第一个子元素，是el-menu-item)
  >.el-menu-item:nth-child(1) {
    order: 1;
  }

  // AI企业营销 - order: 2 (确保在首页和工作流之间)
  >.marketing-menu-item {
    order: 2 !important;
    font-weight: 600;
    font-size: 16px; // 无论点击还是不点击都是16px
    height: 66px !important;
    line-height: 66px !important;
    padding: 0 20px;
    cursor: pointer;
    color: #ffffff;
    position: relative;
    display: inline-block;

    span {
      display: inline-block;
      height: 100%;
      width: 100%;
    }

    &:hover {
      color: #316CF4;
    }

    &.is-active {
      color: #316CF4; // 激活时是蓝色
    }

    // 当首页激活时，AI企业营销应该是白色（不是激活状态）
    .el-menu-item.is-active~& {
      color: #ffffff;

      &:hover {
        color: #316CF4; // 当首页激活时，AI企业营销悬浮时是蓝色
      }
    }
  }

  // 工作流 - order: 3 (第三个子元素，是el-menu-item)
  >.el-menu-item:nth-child(3) {
    order: 3;
  }

  // 智能体 - order: 4 (第四个子元素，是el-menu-item)
  >.el-menu-item:nth-child(4) {
    order: 4;
  }

  .el-menu-item {
    font-weight: 600;
    font-size: 16px;
    border: none !important;
    height: 66px !important;
    line-height: 66px !important;
    max-height: 66px !important;
    padding: 0 20px !important;
    color: #ffffff !important; // 默认是白色
    transition: color 0.3s ease;

    &:hover {
      border: none !important;
      color: #316CF4 !important; // 悬浮时是蓝色
    }

    &.is-active {
      border: none !important;
      color: #316CF4 !important; // 激活时是蓝色
    }
  }

  // 当首页激活时，AI企业营销应该是白色（不是激活状态），但悬浮时是蓝色
  >.el-menu-item:nth-child(1).is-active~.marketing-menu-item {
    color: #ffffff !important;

    &:hover {
      color: #316CF4 !important; // 当首页激活时，AI企业营销悬浮时是蓝色
    }
  }

  // 当首页激活时，其他菜单项（工作流、智能体）悬浮时应该是蓝色
  >.el-menu-item:nth-child(1).is-active~.el-menu-item {
    &:hover {
      color: #316CF4 !important; // 当首页激活时，其他菜单项悬浮时是蓝色
    }
  }

  // 当AI企业营销激活时，其他菜单项悬浮时应该是蓝色
  >.marketing-menu-item.is-active~.el-menu-item {
    color: #ffffff !important;

    &:hover {
      color: #316CF4 !important; // 当AI企业营销激活时，其他菜单项悬浮时是蓝色
    }
  }

  // 当AI企业营销激活时，首页悬浮时也应该是蓝色（首页在AI企业营销之前）
  // 使用父元素选择器来确保当AI企业营销激活时，首页也有hover效果
  &:has(.marketing-menu-item.is-active) {
    >.el-menu-item:nth-child(1):not(.is-active) {
      &:hover {
        color: #316CF4 !important; // 当AI企业营销激活时，首页悬浮时是蓝色
      }
    }
  }
}

// AI企业营销悬停弹窗样式
.marketing-popup {
  position: absolute;
  top: calc(100% + 8px); // 弹窗与导航栏之间的间距是8px
  // left: 40px;
  // margin-left: -398px;
  margin-left: -169px;
  // margin-top: -26px;这个是弹窗整体

  width: 1181px;
  height: 196px;
  background: #232222;
  border-radius: 13px 13px 13px 13px;
  z-index: 1002; // 确保弹窗在模糊背景之上，且高于导航栏
  overflow: hidden;
  // box-shadow: 0 4px 20px #1A1A1A;

  .popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 46px;

    // padding: 16px;
    .popup-title {
      font-weight: 600;
      font-size: 18px;
      color: #fff;
      cursor: pointer;
      transition: color 0.3s ease;

      &:hover {
        color: #316CF4;
      }
    }

    .popup-close {
      cursor: pointer;
      opacity: 0.7;
      transition: opacity 0.3s;
      width: 18px;
      height: 18px;
      object-fit: contain;
      display: block;

      &:hover {
        opacity: 1;
        transform: scale(1.1);
      }
    }
  }

  .popup-divider {
    height: 1px;
    background: #313131;
    margin-left: 46px; // 最左边在"AI企业营销"文字下面（与popup-header的padding-left一致）
    margin-right: 46px; // 最右边到"x"左边下面（与popup-header的padding-right一致）
  }

  .popup-content {
    display: flex;
    padding: 0px 44px;
    gap: 30px;

    .popup-item {
      flex: 1;
      cursor: pointer;
      // padding: 12px;
      border-radius: 4px;
      transition: background-color 0.3s;

      .item-title {
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        margin-bottom: -10px; // "自动评论/弹幕推广"与下面文字间距是13px
        display: inline-block;

        &::after {
          // content: ' >';
          font-size: 14px;
          opacity: 0.7;
        }
      }

      .item-desc {
        font-weight: 400;
        font-size: 14px;
        color: #9D9DA1;
        line-height: 1.6;
        margin-top: -9px;
      }
    }
  }
}

.main-content {
  padding: 0;
  background-color: #121212;
  min-height: calc(100vh - 66px - 200px);
  // background-color: aqua;
}

.footer {
  background-color: #2A2A2A;
  padding: 60px 0 30px 0;
  margin: 0;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

// 左侧：联系我们
.footer-left {
  display: flex;
  flex-direction: column;
}

// 中间：关注数字产线
.footer-middle {
  width: 350px;
  margin-left: 136px;
  display: flex;
  flex-direction: column;
}

// 右侧：查看作品和店铺
.footer-right {
  margin-left: 131px;
  display: flex;
  flex-direction: column;
}

.footer-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 15px;
  margin-top: 0;
}

.footer-text {
  font-family: PingFang SC, PingFang SC;
  font-weight: 300;
  font-size: 13px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  white-space: nowrap;
}

.footer-link {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  text-decoration: underline;
  transition: color 0.3s ease;

  &:hover {
    color: #316CF4;
  }
}

.footer-phone {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.footer-contact-item {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  &:last-child {
    margin-bottom: 0;
  }
}

.footer-description {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 1.6;
  margin-bottom: 20px;
}

.qr-codes-container {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.qr-code-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.qr-code-image {
  width: 67px;
  height: 67px;
  object-fit: contain;
}

.qr-code-label {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #FFFFFF;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.footer-works-section {
  margin-bottom: 30px;
}

.footer-store-section {
  margin-bottom: 0;
}

.platform-icons-container {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
}

.platform-icon-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.platform-icon {
  width: 38px;
  height: 38px;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
}

// 用户信息悬停弹窗样式
.user-popup {
  position: absolute;
  top: 100%;
  right: 0;
  width: 337px;
  height: 285px;
  background: rgba(21, 24, 28, 0.95);
  border-radius: 11px 11px 11px 11px;
  border: 1px solid #292E35;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
  z-index: 10005;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 13px;
  opacity: 1;
  transform: translateY(0);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;

  // 添加进入动画
  &.popup-enter-active {
    opacity: 0;
    transform: translateY(-10px);
  }

  &.popup-enter-to {
    opacity: 1;
    transform: translateY(0);
  }

  // 添加离开动画
  &.popup-leave-active {
    opacity: 1;
    transform: translateY(0);
  }

  &.popup-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }

  .popup-module {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
      margin-top: auto; // 将最后一个模块推到底部
    }
  }

  // 第一个模块：用户信息
  .user-info-module {
    display: flex;
    align-items: flex-start;
    gap: 12px;

    .user-avatar-section {
      .popup-avatar {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        object-fit: cover;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 12px rgba(49, 108, 244, 0.3);
        }

        &:active {
          transform: scale(0.95);
        }
      }
    }

    .user-text-section {
      flex: 1;

      .user-name-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;

        .user-name {
          color: #E4E4E1;
          font-size: 14px;
          font-weight: 500;
        }

        .level-icon {
          width: 18px;
          height: 18px;
          object-fit: contain;
        }
      }

      .user-id-row {
        display: flex;
        align-items: center;
        gap: 8px;

        .user-id {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #E4E4E1;
        }

        .vertical-separator {
          width: 13px;
          height: 0px;
          border-radius: 0px 0px 0px 0px;
          border: 1px solid #443F3A;
          transform: rotate(90deg);
        }

        .logout-text {
          font-weight: 500;
          font-size: 12px;
          color: #E4E4E1;
          cursor: pointer;
          transition: all 0.3s ease;
          padding: 4px 0px;
          border-radius: 4px;

          &:hover {
            color: #FFFFFF;
            background: rgba(203, 68, 74, 0.2);
          }

          &:active {
            transform: scale(0.95);
          }
        }
      }
    }
  }

  // 第二个模块：VIP信息
  .vip-module {
    .vip-background {
      position: relative;
      // background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
      border-radius: 8px;
      height: 64px;
      width: 295px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      overflow: hidden;

      .vip-bg-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 1;
      }

      .vip-left {
        position: absolute;
        bottom: 14px;
        left: 62px;
        z-index: 2;

        .vip-expire {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 11px;
          color: #74654E;
          text-align: left;
          font-style: normal;
          text-transform: none;
          white-space: nowrap;
          transition: all 0.3s ease;
        }
      }

      .vip-right {
        position: relative;
        z-index: 2;
        right: 19px;

        .upgrade-btn {
          width: 59px;
          height: 26px;
          background: linear-gradient(180deg, #545454 0%, #313131 100%);
          border-radius: 5px 5px 5px 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 11px;
          color: #D5BE9E;
          text-align: left;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(84, 84, 84, 0.3);
          }
        }

        .renewal-btn {
          width: 59px;
          height: 26px;
          background: linear-gradient(180deg, #545454 0%, #313131 100%);
          border-radius: 5px 5px 5px 5px;
          border: 1px solid #000000;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 11px;
          color: #D5BE9E;
          text-align: left;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(84, 84, 84, 0.3);
          }
        }
      }
    }
  }

  // 第三个模块：调用次数
  .call-counts-module {
    .call-count-row {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-weight: 500;
      font-size: 13px;
      color: #C4C1BF;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      .call-label {
        flex: 1;
      }

      .call-value {
        margin-left: 10px;
        font-weight: 600;
      }
    }
  }

  // 水平分割线
  .horizontal-separator {
    width: 295px;
    height: 0px;
    border-radius: 0px 0px 0px 0px;
    border-top: 1px solid #443F3A;
    margin-top: 0;
    margin-bottom: 16px;
  }

  // 第四个模块：进入主页
  .homepage-module {
    position: relative;
    margin-top: 0px !important; // 向上移动，使"进入我的主页"更靠近分割线

    .homepage-content {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      cursor: pointer;
      padding: -4px 16px;
      border-radius: 6px;
      transition: all 0.3s ease;
      position: relative;
      z-index: 1;
    }

    .homepage-text {
      font-weight: 600;
      font-size: 13px;
      color: #C4C1BF;
      transition: color 0.3s ease;
      white-space: nowrap;
    }

    .homepage-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
    }

    .homepage-status {
      display: flex;
      align-items: center;
      gap: 4px;
      background: rgba(49, 108, 244, 0.1);
      border-radius: 4px;
      padding: 2px 6px;
      font-size: 10px;
      font-weight: 500;
      color: #316CF4;
      transition: all 0.3s ease;

      .status-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #316CF4;
        animation: statusPulse 2s infinite;

        &.online {
          background-color: #4CAF50;
        }

        &.offline {
          background-color: #9E9E9E;
        }

        &.busy {
          background-color: #FF9800;
        }
      }

      .status-text {
        font-size: 10px;
        font-weight: 500;
        color: inherit;
      }

      .arrow-icon {
        width: 8px;
        height: 17px;
        object-fit: contain;
        transition: all 0.3s ease;
        margin-left: 4px;
      }

      &:hover {
        background: rgba(49, 108, 244, 0.2);
        transform: scale(1.05);
      }
    }

    .visit-count {
      display: flex;
      align-items: center;
      gap: 4px;

      .count-text {
        font-size: 10px;
        font-weight: 500;
        color: #C4C1BF;
        background: rgba(196, 193, 191, 0.1);
        padding: 2px 6px;
        border-radius: 3px;
        white-space: nowrap;
        transition: all 0.3s ease;

        &:hover {
          background: rgba(196, 193, 191, 0.2);
          color: #FFFFFF;
        }
      }

      .last-visit {
        font-size: 9px;
        color: #9D9DA1;
        background: rgba(157, 157, 161, 0.1);
        padding: 1px 4px;
        border-radius: 2px;
        white-space: nowrap;
        transition: all 0.3s ease;

        &:hover {
          background: rgba(157, 157, 161, 0.2);
          color: #C4C1BF;
        }
      }
    }

    &:hover {
      .homepage-text {
        color: #316CF4;
      }

      .homepage-status .arrow-icon {
        transform: translateX(2px);
        filter: brightness(1.2);
      }
    }
  }

  // 添加点击波纹效果
  &.clicked {
    .homepage-content {
      animation: clickRipple 0.6s ease;
    }
  }
}


.footer-bottom {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 30px;
  gap: 7px;
  max-width: 1180px;
  margin: 0 auto;
  margin-top: 40px;
  border-top: 1px solid #3A3A3A;
}

.footer-logo {
  display: flex;
  align-items: center;
}

.logo-image {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.footer-copyright {
  color: #9D9DA1;
  font-size: 14px;
}

.footer-icp {
  color: #9D9DA1;
  font-size: 14px;
}

.footer-icp a {
  color: #9D9DA1;
  text-decoration: none;
}

.footer-icp a:hover {
  color: #ffffff;
  text-decoration: underline;
}

// 登录弹窗样式
.login-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.login-modal {
  width: 650px;
  height: 429px;
  background: #1A1A1A;
  border-radius: 14px 14px 14px 14px;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.login-header {
  text-align: center;
  margin-bottom: 20px;
}

.login-title {
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  margin: 0 0 0 0;
}

.login-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
}

.login-image {
  width: 90px;
  height: 8px;
}

.login-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
}

.form-input {
  width: 100%;
  height: 40px;
  background: #2A2A2A;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #3A3A3A;
  padding: 0 12px;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  box-sizing: border-box;
}

.form-input::placeholder {
  color: #6E757C;
}

.form-tip {
  font-size: 12px;
  color: #6E757C;
  margin-top: 4px;
  font-style: italic;
}

.phone-input {
  width: 590px;
}

.verification-container {
  display: flex;
  gap: 15px;
  align-items: center;
}

.verification-input {
  width: 459px;
  flex-shrink: 0;
}

.get-code-btn {
  width: 116px;
  height: 40px;
  border-radius: 4px 4px 4px 4px;
  border: 1.5px solid #316CF4;
  border-radius: 4px 4px 4px 4px;
  background: transparent;
  font-weight: 500;
  font-size: 16px;
  color: #316CF4;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.get-code-btn:hover:not(:disabled) {
  background: rgba(49, 108, 244, 0.1);
}

.get-code-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-footer {
  text-align: center;
}

.login-btn {
  width: 136px;
  height: 39px;
  background: linear-gradient(90deg, #316CF4 0%, #01FAE7 100%);
  border-radius: 20px 20px 20px 20px;
  border: none;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 15px;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(49, 108, 244, 0.3);
}

.register-link {
  display: flex;
  justify-content: center;
  gap: 5px;
}

.register-text {
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
}

.register-action {
  font-weight: 400;
  font-size: 16px;
  color: #316CF4;
  cursor: pointer;
  transition: color 0.3s ease;
}

.register-action:hover {
  color: #01FAE7;
}

// 注册弹窗样式
.register-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.register-modal {
  width: 650px;
  height: 550px;
  background: #1A1A1A;
  border-radius: 14px 14px 14px 14px;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.register-header {
  text-align: center;
  margin-bottom: 20px;
}

.register-title {
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  margin: 0 0 0 0;
}

.register-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
}

.register-image {
  width: 90px;
  height: 8px;
}

.register-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}

.required-star {
  color: #CA444A;
  margin-left: 2px;
}

.optional-text {
  color: #6E757C;
  margin-left: 2px;
}

.invitation-input {
  width: 590px;
}

.agreement-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: -3px;
}

.agreement-checkbox {
  width: 14px;
  height: 14px;
  background: #2A2A2A;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #3A3A3A;
  cursor: pointer;
}

.agreement-text {
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  cursor: pointer;
}

.agreement-link {
  font-weight: 500;
  font-size: 14px;
  color: #316CF4;
  cursor: pointer;
  transition: color 0.3s ease;
}

.agreement-link:hover {
  color: #01FAE7;
}

.register-footer {
  text-align: center;
}

.register-btn {
  width: 136px;
  height: 39px;
  background: linear-gradient(90deg, #316CF4 0%, #01FAE7 100%);
  border-radius: 20px 20px 20px 20px;
  border: none;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 15px;
}

.register-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(49, 108, 244, 0.3);
}

.login-link {
  display: flex;
  justify-content: center;
  gap: 5px;
}

.login-text {
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
}

.login-action {
  font-weight: 400;
  font-size: 16px;
  color: #316CF4;
  cursor: pointer;
  transition: color 0.3s ease;
}

.login-action:hover {
  color: #01FAE7;
}

// 会员升级弹窗样式
.membership-upgrade-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.membership-upgrade-modal {
  width: 1180px;
  height: 669px;
  background: linear-gradient(90deg, #F0CC98 0%, #DAA14E 48%, #F0D0A1 100%);
  border-radius: 14px;
  position: relative;
}

.membership-header {
  width: 100%;
  height: 140px;
  background: url('@/assets/images/M-1405.png') no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 40px;
  box-sizing: border-box;
  border-radius: 14px 14px 0 0;
  overflow: hidden;
  position: relative;
}

.membership-header-left {
  display: flex;
  align-items: center;
  gap: 15px;
  width: 200px;
  /* 固定左侧区域宽度 */
}

.user-avatar-section {
  .membership-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }
}

.account-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.account-text {
  font-weight: 500;
  font-size: 16px;
  color: #AB6924;
  white-space: nowrap;
  /* 防止文字换行，确保在一排显示 */
}

.expiry-text {
  font-weight: 500;
  font-size: 12px;
  color: #AB6924;
  white-space: nowrap;
}

.status-badge {
  width: 49px;
  height: 21px;
  background: #C49B70;
  border-radius: 4px 4px 4px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  color: #FFFFFF;
}

/* 添加M-1404图片样式 */
.status-image {
  width: 49px;
  height: 21px;
  object-fit: contain;
}

.membership-header-right {
  text-align: left;
  margin-left: 122px;
  /* 精确的122px间距 */
  flex: 1;
}

.privileges-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #AB6924;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 15px;
  line-height: 1;
  /* 确保与充值账号文字基线对齐 */
}

.privileges-list {
  display: flex;
  gap: 20px;
}

.privilege-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.privilege-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.privilege-text {
  font-weight: 400;
  font-size: 14px;
  color: #B87D35;
  white-space: nowrap;
}

.membership-content {
  width: 100%;
  height: 565px;
  background: #1A1A1A;
  border-radius: 0 0 14px 14px;
  padding: 40px;
  box-sizing: border-box;
  display: flex;
  gap: 0px;
  /* 移除gap，改为通过padding控制间隔 */
  overflow: hidden;
  /* 防止子元素溢出圆角区域 */
}

.vip-plans-section {
  flex: 1;
  display: flex;
  gap: 20px;
  padding-right: 40px;
  /* 添加右边距，与第三部分保持40px间隔 */
  box-sizing: border-box;
}

.vip-plan-card {
  width: 320px;
  height: 472px;
  background: #222529;
  border-radius: 12px 12px 12px 12px;
  padding: 30px;
  text-align: center;
  /* 改为居中对齐 */
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 改为居中对齐 */
  gap: 15px;
  position: relative;
  opacity: 1;
  /* 取消透明度 */

  &.selected {
    background: linear-gradient(271deg, #1C51E2 0%, #2781F2 100%);

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('@/assets/images/M-1406.png') no-repeat center center;
      background-size: cover;
      border-radius: 12px;
      opacity: 0.3;
    }
  }

  &:hover {
    transform: translateY(-5px);
  }
}

.plan-title {
  font-weight: 500;
  font-size: 22px;
  color: #FFFFFF;
  z-index: 1;
  position: relative;
}

.plan-subtitle {
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  z-index: 1;
  position: relative;
  margin-bottom: 65px;
  /* 减小底部间距，与"199元/年"保持距离 */
}

.plan-price {
  display: flex;
  align-items: baseline;
  gap: 5px;
  z-index: 1;
  position: relative;
  margin-top: 0;
  /* 重置顶部间距 */
}

.price-number {
  font-weight: 500;
  font-size: 40px;
  color: #F8DD9D;
}

/* 为被选中的VIP卡片添加特殊颜色 */
.vip-plan-card.selected .price-number {
  color: #FFFFFF;
}

.price-unit {
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
}

.plan-divider {
  display: flex;
  align-items: center;
  margin: 20px 0;
  z-index: 1;
  position: relative;
}

.divider-line {
  width: 70px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  border: 1px dashed #FFFFFF;
  /* 改为虚线 */
}

.divider-text {
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  margin: 0 15px;
}

.plan-benefits {
  line-height: 1.8;
  z-index: 1;
  position: relative;
  width: 100%;
  /* 确保权益区域占满宽度 */
  text-align: left;
  /* 权益内容保持左对齐 */
}

.benefit-item {
  margin-bottom: 8px !important;
  display: flex !important;
  justify-content: space-between !important;
  /* 让左右内容分布在两端 */
  width: 100% !important;
  align-items: center !important;
}

.benefit-item span:first-child {
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #FFFFFF !important;
  text-align: left !important;
  font-style: normal !important;
  text-transform: none !important;
  flex: 1 !important;
  margin-right: 20px !important;
  /* 增加右边距 */
}

.benefit-item span:last-child {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #FFFFFF !important;
  text-align: right !important;
  font-style: normal !important;
  text-transform: none !important;
  flex-shrink: 0 !important;
  width: 70px !important;
  /* 精确设置宽度与虚线一致 */
  display: block !important;
  white-space: nowrap !important;
  /* 防止换行 */
  padding-right: 0px !important;
  /* 去掉右边内边距，让文字贴着边缘 */
  margin-left: auto !important;
  /* 确保右对齐 */
}

.content-separator {
  width: 0px;
  height: 483px;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #3C3C3C;
  margin: 0 20px 0 0;
  /* 右边距20px，左边距0px，让分割线往左移动20px */
}

.payment-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  margin-left: 0px;
  /* 向右移动 */
  padding-left: 0px;
  /* 重置padding */
  box-sizing: border-box;
}

.payment-container {
  width: 390px;
  height: 483px;
  background: transparent;
  /* 取消背景色 */
  border-radius: 0px;
  /* 取消圆角 */
  padding: 30px 30px 30px 30px;
  /* 顶部padding与VIP卡片一致，使二维码顶部与"企业VIP"对齐 */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: visible;
  border: none;
  /* 取消边框 */
}

.payment-title {
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
  margin: 0 0 24px 0;
  /* 第一行和第二行之间的距离是24px */
  text-align: left;
  padding: 0;
  line-height: 1;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  left: 0;
  transform: translateX(0);
  align-self: flex-start;
  float: left;
  clear: both;
  padding-left: 0;
  margin-left: 0;
}

.payment-methods {
  display: flex;
  gap: 4px;
  margin: 0 0 30px 0;
  /* 从67px减小到30px，确保所有内容都在div内 */
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  margin-left: -1px;
  position: relative;
  left: 0;
  transform: translateX(0);
  align-self: flex-start;
  max-width: 100%;
  float: left;
  clear: both;
  padding-left: 0;
  text-indent: 0;
}

.payment-method {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 0;

  input[type="radio"] {
    width: 16px;
    height: 16px;
    margin: 0;
    cursor: pointer;
    flex-shrink: 0;
  }

  .payment-text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

.radio-button {
  width: 16px;
  height: 16px;
  background: #2A2A2A;
  border-radius: 50%;
  /* 改为圆形 */
  border: 1px solid #3A3A3A;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &.selected {
    background: #316CF4;
    border-color: #316CF4;
  }
}

.payment-icon {
  width: 19px;
  height: 19px;
  object-fit: contain;
  flex-shrink: 0;
}


.qr-payment-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin: 0 0 20px 0;
  /* 删除顶部margin，使二维码顶部与"企业VIP"对齐 */
}

.payment-right-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin-top: 56px;
}

.qr-code-section {
  flex-shrink: 0;
}

.qr-code {
  width: 137px;
  height: 140px;
  object-fit: contain;
}


.qr-loading {
  width: 137px;
  height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #FFFFFF;
  font-size: 12px;
  gap: 8px;
}

.loading-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid transparent;
  border-top: 2px solid #F8DD9D;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.amount-section {
  display: flex;
  align-items: center;
  gap: 16px;
  /* 添加间距，让按钮与金额之间有距离 */
  flex-shrink: 0;
  align-self: flex-start;
  /* 改为左对齐 */
  white-space: nowrap;
  /* 确保在一行显示 */
}

.amount-label {
  font-weight: 400;
  /* 改为400 */
  font-size: 16px;
  color: #FFFFFF;
}

.amount-value {
  font-weight: 400;
  /* 改为400 */
  font-size: 30px;
  /* 改为30px */
  color: #F8DD9D;
  /* 改为#F8DD9D */
}

.pay-now-btn {
  padding: 10px 24px;
  background: #7657FF;
  border-radius: 10px;
  border: none;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  transition: background 0.3s ease;

  &:hover:not(:disabled) {
    background: #6349E0;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.tips-title {
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 21px;
  margin: 0 0 15px 0;
  /* 添加底部间距15px，与下面内容保持距离 */
  text-align: left;
  width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
  padding: 0;
  max-width: 100%;
  word-break: keep-all;
  display: block;
  visibility: visible;
  opacity: 1;
  word-spacing: 0px;
  letter-spacing: 0px;
  position: relative;
  left: 0;
  right: 0;
  transform: translateX(0);
}

.tips-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  /* 确保内容区域占满宽度 */
  overflow: visible;
  /* 确保内容可见 */
}

.tip-item {
  font-weight: 500;
  font-size: 14px;
  color: #9D9DA1;
  line-height: 21px;
  text-align: left;
  width: 100%;
  /* 确保每行占满宽度 */
  word-wrap: break-word;
  /* 允许长文字换行 */
  white-space: normal;
  /* 允许正常换行 */
}

.contact-link {
  font-weight: 500;
  font-size: 14px;
  color: #03F5E7;
  cursor: pointer;
  text-decoration: underline;
}

.contact-link:hover {
  color: #01FAE7;
}

// 响应式设计
@media (max-width: 768px) {
  .footer {
    padding: 40px 0 20px 0;
  }

  .footer-content {
    padding: 0 15px;
  }

  .footer-navigation {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-bottom: 40px;
  }

  .footer-title {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .footer-content {
    flex-direction: column;
    gap: 30px;
  }

  .footer-left {
    width: 100%;
  }

  .footer-middle {
    width: 100%;
    margin-left: 0;
  }

  .footer-right {
    margin-left: 0;
  }

  .qr-codes-container {
    justify-content: flex-start;
  }

  .platform-icons-container {
    justify-content: flex-start;
  }

  .logo-image {
    width: 35px;
    height: 35px;
  }

  .footer-copyright {
    font-size: 13px;
  }

  .footer-icp {
    font-size: 13px;
  }

  // 登录弹窗响应式
  .login-modal {
    width: 90%;
    height: auto;
    min-height: 400px;
    margin: 20px;
  }

  .phone-input {
    width: 100%;
  }

  .verification-container {
    flex-direction: column;
    gap: 10px;
  }

  .verification-input {
    width: 100%;
  }

  .get-code-btn {
    width: 100%;
  }

  // 注册弹窗响应式
  .register-modal {
    width: 90%;
    height: auto;
    min-height: 500px;
    margin: 20px;
  }

  .invitation-input {
    width: 100%;
  }

  // 会员升级弹窗响应式
  .membership-upgrade-modal {
    width: 90%;
    height: auto;
    min-height: 600px;
    margin: 20px;
  }

  .vip-plans-section {
    flex-direction: column;
    gap: 15px;
  }

  .vip-plan-card {
    width: 100%;
    padding: 15px;
    text-align: center;
    /* 移动端也保持居中对齐 */
    align-items: center;
    /* 移动端也保持居中对齐 */
  }

  .plan-title {
    font-size: 16px;
  }

  .plan-subtitle {
    font-size: 13px;
  }

  .plan-price {
    font-size: 20px;
  }

  .price-number {
    font-size: 30px;
  }

  .price-unit {
    font-size: 14px;
  }

  .plan-divider {
    margin: 10px 0;
  }

  .divider-line {
    height: 0.5px;
  }

  .divider-text {
    font-size: 12px;
  }

  .plan-benefits {
    line-height: 1.6;
    width: 100%;
    /* 确保权益区域占满宽度 */
    text-align: left;
    /* 权益内容保持左对齐 */
  }

  .benefit-item {
    margin-bottom: 6px !important;
    display: flex !important;
    justify-content: space-between !important;
    width: 100% !important;
    align-items: center !important;
  }

  .benefit-item span:first-child {
    font-size: 12px !important;
    text-align: left !important;
    flex: 1 !important;
    margin-right: 15px !important;
  }

  .benefit-item span:last-child {
    font-size: 12px !important;
    text-align: right !important;
    flex-shrink: 0 !important;
    width: 60px !important;
    /* 精确设置宽度 */
    display: block !important;
    white-space: nowrap !important;
    padding-right: 0px !important;
    /* 去掉右边内边距，让文字贴着边缘与虚线对齐 */
    margin-left: auto !important;
    /* 确保右对齐 */
  }

  .payment-methods {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
  }

  .payment-method {
    width: 100%;
    justify-content: center;
    padding: 10px 15px;
  }

  .qr-code {
    width: 120px;
    height: 120px;
  }



  .amount-section {
    font-size: 20px;
    display: flex !important;
    /* 确保移动端也在一行显示 */
    align-items: center !important;
    white-space: nowrap !important;
    /* 确保在一行显示 */
    gap: 12px !important;
  }

  .amount-label {
    font-size: 14px;
  }

  .amount-value {
    font-size: 24px;
  }

  .pay-now-btn {
    padding: 8px 20px;
    font-size: 14px;
  }

  .tips-section {
    padding-left: 0;
    text-align: center;
  }

  .tips-title {
    font-size: 13px;
  }

  .tip-item {
    font-size: 12px;
  }

  .contact-link {
    font-size: 12px;
  }
}

// 响应式设计 768
@media (max-width: 968px) {
  .header-content {
    flex-direction: column;
    height: auto;
    padding: 10px;

    .logo {
      margin-bottom: 10px;
    }

    .el-menu {
      margin-bottom: 10px;
    }
  }
}

// 添加点击波纹动画
@keyframes clickRipple {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

// 添加状态脉冲动画
@keyframes statusPulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.7;
    transform: scale(1.2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

// 自定义成功消息样式
.custom-success-message {
  .el-message__content {
    font-size: 16px;
    font-weight: 600;
    color: #4CAF50;
  }

  .el-message__description {
    margin-top: 8px;
    font-size: 14px;
    color: #666;
    line-height: 1.5;
  }

  .el-message__icon {
    color: #4CAF50;
    font-size: 24px;
  }
}

// 注册成功消息样式 - 最高优先级
.register-success-message {
  z-index: 2147483647 !important;
  /* 绝对最高优先级 */
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  transform: translateZ(0) !important;
  /* 强制硬件加速 */
  will-change: transform !important;
  isolation: isolate !important;
  /* 创建新的层叠上下文 */

  .el-message__content {
    font-size: 18px !important;
    /* 更大的字体 */
    font-weight: 700 !important;
    /* 更粗的字体 */
    color: #52C41A !important;
    /* 更亮的绿色 */
    text-shadow: none !important;
    -webkit-text-shadow: none !important;
    -moz-text-shadow: none !important;
    -o-text-shadow: none !important;
    filter: none !important;
    background: rgba(255, 255, 255, 0.98) !important;
    /* 半透明背景 */
    padding: 12px 16px !important;
    border-radius: 8px !important;
  }

  .el-message__icon {
    color: #52C41A !important;
    font-size: 22px !important;
  }

  // 强化的阴影效果，确保突出显示
  box-shadow: 0 6px 16px rgba(82, 196, 26, 0.4),
  0 0 0 1px rgba(82, 196, 26, 0.2),
  0 0 20px rgba(82, 196, 26, 0.1) !important;

  border: 3px solid #52C41A !important;

  // 覆盖所有可能的样式和层级
  &,
  *,
  &::before,
  &::after,
  .el-message {
    text-shadow: none !important;
    -webkit-text-shadow: none !important;
    -moz-text-shadow: none !important;
    -o-text-shadow: none !important;
    filter: none !important;
    z-index: 2147483647 !important;
    position: relative !important;
    transform: translateZ(0) !important;

    // 确保在所有浏览器中都可见
    -webkit-transform: translateZ(0) !important;
    -moz-transform: translateZ(0) !important;
    -ms-transform: translateZ(0) !important;
    -o-transform: translateZ(0) !important;
  }
}

// 登录消息样式 - 提高优先级和可见性
.login-success-message {
  z-index: 2147483647 !important;
  /* 最大可能的z-index值 */
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  transform: translateZ(0) !important;
  /* 强制硬件加速 */
  will-change: transform !important;

  .el-message__content {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #67C23A !important;
    text-shadow: none !important;
    -webkit-text-shadow: none !important;
    -moz-text-shadow: none !important;
    -o-text-shadow: none !important;
    filter: none !important;
  }

  .el-message__icon {
    color: #67C23A !important;
    font-size: 20px !important;
  }

  // 确保消息框本身没有阴影遮挡
  box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3) !important;
  border: 2px solid #67C23A !important;

  // 强制提升层级
  isolation: isolate !important;

  // 覆盖所有可能的阴影样式和层级
  &,
  *,
  &::before,
  &::after,
  .el-message {
    text-shadow: none !important;
    -webkit-text-shadow: none !important;
    -moz-text-shadow: none !important;
    -o-text-shadow: none !important;
    filter: none !important;
    z-index: 2147483647 !important;
    position: relative !important;
    transform: translateZ(0) !important;
  }
}

.login-error-message {
  z-index: 2147483647 !important;
  /* 最大可能的z-index值 */
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  transform: translateZ(0) !important;
  /* 强制硬件加速 */
  will-change: transform !important;

  .el-message__content {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #F56C6C !important;
    text-shadow: none !important;
    -webkit-text-shadow: none !important;
    -moz-text-shadow: none !important;
    -o-text-shadow: none !important;
    filter: none !important;
  }

  .el-message__icon {
    color: #F56C6C !important;
    font-size: 20px !important;
  }

  // 确保消息框本身没有阴影遮挡
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3) !important;
  border: 2px solid #F56C6C !important;

  // 强制提升层级
  isolation: isolate !important;

  // 覆盖所有可能的阴影样式和层级
  &,
  *,
  &::before,
  &::after,
  .el-message {
    text-shadow: none !important;
    -webkit-text-shadow: none !important;
    -moz-text-shadow: none !important;
    -o-text-shadow: none !important;
    filter: none !important;
    z-index: 2147483647 !important;
    position: relative !important;
    transform: translateZ(0) !important;
  }
}

.logout-success-message {
  z-index: 2147483647 !important;
  /* 最大可能的z-index值 */
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  transform: translateZ(0) !important;
  /* 强制硬件加速 */
  will-change: transform !important;

  .el-message__content {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #67C23A !important;
    text-shadow: none !important;
    -webkit-text-shadow: none !important;
    -moz-text-shadow: none !important;
    -o-text-shadow: none !important;
    filter: none !important;
  }

  .el-message__icon {
    color: #67C23A !important;
    font-size: 20px !important;
  }

  // 确保消息框本身没有阴影遮挡
  box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3) !important;
  border: 2px solid #67C23A !important;

  // 强制提升层级
  isolation: isolate !important;

  // 覆盖所有可能的阴影样式和层级
  &,
  *,
  &::before,
  &::after,
  .el-message {
    text-shadow: none !important;
    -webkit-text-shadow: none !important;
    -moz-text-shadow: none !important;
    -o-text-shadow: none !important;
    filter: none !important;
    z-index: 2147483647 !important;
    position: relative !important;
    transform: translateZ(0) !important;
  }
}


// 支付跳转弹窗样式
.payment-redirect-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.payment-redirect-modal {
  width: 1000px;
  height: 95vh;
  max-height: 95vh;
  background: #FFFFFF;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.payment-redirect-header {
  width: 100%;
  height: 60px;
  background: #316CF4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}

.payment-redirect-title {
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
}

.payment-redirect-close {
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  color: #FFFFFF;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover {
    opacity: 0.8;
  }
}

.payment-redirect-content {
  flex: 1;
  padding: 0;
  overflow: hidden;
  background: #FFFFFF;
  position: relative;
  height: calc(95vh - 60px);
  display: flex;
  flex-direction: column;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
    flex: 1;
  }
}

/* 留言咨询弹窗（与短剧端 App 咨询弹窗布局一致，z-index 高于客服弹窗） */
.consult-modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(5, 7, 11, 0.72);
  z-index: 10010;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.consult-modal {
  position: relative;
  width: 527px;
  max-width: 100%;
  height: 778px;
  max-height: calc(100vh - 48px);
  background: #1a1a1a;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.55);
  box-sizing: border-box;
  overflow: hidden;
}

.consult-modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.45);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  padding: 4px 8px;
}

.consult-modal-close:hover {
  color: rgba(255, 255, 255, 0.85);
}

.consult-modal-inner {
  height: 100%;
  padding: 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.consult-modal-head {
  flex-shrink: 0;
  padding-right: 36px;
}

.consult-modal-title {
  margin: 0;
  font-family: HYQiHei, HYQiHei, 'PingFang SC', sans-serif;
  font-weight: normal;
  font-size: 25px;
  color: #ffffff;
  line-height: 1.35;
}

.consult-modal-subtitle {
  margin: 12px 0 0;
  font-family: PingFang SC, PingFang SC, sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #a2a2a2;
  line-height: 1.55;
}

.consult-modal-form {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-top: 28px;
  padding-right: 4px;
}

.consult-modal-form::-webkit-scrollbar {
  width: 4px;
}

.consult-modal-form::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}

.consult-field-group {
  margin-bottom: 20px;
}

.consult-field-group:last-child {
  margin-bottom: 0;
}

.consult-label {
  display: block;
  margin-bottom: 8px;
  font-family: PingFang SC, PingFang SC, sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}

.consult-field {
  width: 100%;
  box-sizing: border-box;
  height: 34px;
  padding: 0 14px;
  border: 1px solid #3a3a3a;
  border-radius: 8px;
  background: #2a2a2a;
  font-family: PingFang SC, PingFang SC, sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  outline: none;
}

.consult-field:not(.consult-field--select):placeholder-shown {
  color: #767676;
}

.consult-field::placeholder {
  color: #767676;
}

.consult-field--select.consult-field--muted {
  color: #767676;
}

.consult-field:focus {
  border-color: rgba(118, 87, 255, 0.55);
}

.consult-field--textarea {
  height: auto;
  min-height: 88px;
  padding: 12px 14px;
  resize: vertical;
  line-height: 1.5;
}

.consult-select-wrap {
  position: relative;
}

.consult-select-wrap::after {
  content: '›';
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: rgba(255, 255, 255, 0.4);
  line-height: 1;
  pointer-events: none;
}

.consult-field--select {
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  padding-right: 36px;
}

.consult-field--select option {
  background: #2b2b2b;
  color: #fff;
}

.consult-modal-footer {
  flex-shrink: 0;
  padding-top: 24px;
}

.consult-submit-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #7657ff 0%, #a357ff 100%);
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.consult-submit-btn:hover:not(:disabled) {
  opacity: 0.95;
}

.consult-submit-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

// 客服弹窗样式
.customer-service-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.customer-service-modal {
  width: 500px;
  height: 400px;
  background: #FFFFFF;
  border-radius: 10px 10px 10px 10px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.customer-service-header {
  width: 100%;
  height: 65px;
  background: #316CF4;
  display: flex;
  align-items: center;
  padding: 0 20px;
  gap: 12px;
  box-sizing: border-box;
}

.service-icon {
  width: 28px;
  height: 28px;
}

.service-title {
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  text-align: left;
}

.customer-service-content {
  padding: 20px;
  height: calc(340px - 65px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.qr-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.qr-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.scan-icon {
  width: 18px;
  height: 18px;
}

.scan-text {
  font-weight: 500;
  font-size: 18px;
  color: #316CF4;
}

.working-hours {
  font-weight: 400;
  font-size: 18px;
  color: #6E757C;
  text-align: center;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.qr-code {
  width: 139px;
  height: 126px;
}

.wechat-section {
  width: 450px;
  height: 85px;
  background: #EAF0FF;
  border-radius: 8px;
  border: 1px solid #316CF4;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.wechat-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.wechat-label {
  font-weight: 500;
  font-size: 16px;
  color: #316CF4;
}

.copy-icon {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.note-text {
  font-weight: 500;
  font-size: 16px;
  color: #6E757C;
}

// 响应式设计</style>
